/* eslint-disable import/order */
import * as React from 'react';
import SVG from 'react-svg-inline';

import AddColorSvg from './common/add-color.svg';
export const AddColor = (_p) => (<SVG svg={AddColorSvg}/>);
import AddLayerSvg from './common/add-layer.svg';
export const AddLayer = (_p) => (<SVG svg={AddLayerSvg}/>);
import AddToMapSvg from './common/add_to_map.svg';
export const AddToMap = (_p) => (<SVG svg={AddToMapSvg}/>);
import AddUserSvg from './common/add-user.svg';
export const AddUser = (_p) => (<SVG svg={AddUserSvg}/>);
import AdminSvg from './common/admin.svg';
export const Admin = (_p) => (<SVG svg={AdminSvg}/>);
import AllOutSvg from './common/all_out.svg';
export const AllOut = (_p) => (<SVG svg={AllOutSvg}/>);
import AreaSheduleSvg from './analytics/areashedule.svg';
export const AreaShedule = (_p) => (<SVG svg={AreaSheduleSvg}/>);
import CommercialSvg from './analytics/commercial.svg';
export const Commercial = (_p) => (<SVG svg={CommercialSvg}/>);
import DbSvg from './analytics/db.svg';
export const Db = (_p) => (<SVG svg={DbSvg}/>);
import MetricsSvg from './analytics/metrics.svg';
export const Metrics = (_p) => (<SVG svg={MetricsSvg}/>);
import PercentageSvg from './analytics/percentage.svg';
export const Percentage = (_p) => (<SVG svg={PercentageSvg}/>);
import SummarySvg from './analytics/summary.svg';
export const Summary = (_p) => (<SVG svg={SummarySvg}/>);
import WidgetSvg from './analytics/widget.svg';
export const Widget = (_p) => (<SVG svg={WidgetSvg}/>);
import AnalyticsSvg from './common/analytics.svg';
export const Analytics = (_p) => (<SVG svg={AnalyticsSvg}/>);
import ApproximateSvg from './common/approximate.svg';
export const Approximate = (_p) => (<SVG svg={ApproximateSvg}/>);
import ArchitectureSvg from './common/architecture.svg';
export const Architecture = (_p) => (<SVG svg={ArchitectureSvg}/>);
import PlaceholderSvg from './common/Placeholder.svg';
export const Placeholder = (_p) => (<SVG svg={PlaceholderSvg}/>);

import AreaSvg from './architecture3d/Area.svg';
export const Area = (_p) => (<SVG svg={AreaSvg}/>);
import ArrowArchitecture3dSvg from './architecture3d/arrow.svg';
export const ArrowArchitecture3d = (_p) => (<SVG svg={ArrowArchitecture3dSvg}/>);
import AssemblySvg from './architecture3d/Assembly.svg';
export const Assembly = (_p) => (<SVG svg={AssemblySvg}/>);
import CameraArchitecture3dSvg from './architecture3d/camera.svg';
export const CameraArchitecture3d = (_p) => (<SVG svg={CameraArchitecture3dSvg}/>);
import ColorSvg from './architecture3d/Color.svg';
export const Color = (_p) => (<SVG svg={ColorSvg}/>);
import CrosssectionSvg from './architecture3d/crosssection.svg';
export const Crosssection = (_p) => (<SVG svg={CrosssectionSvg}/>);
import ArchitecturalelementSvg from './architecture3d/elements/architecturalelement.svg';
export const Architecturalelement = (_p) => (<SVG svg={ArchitecturalelementSvg}/>);
import BalconyArchitecture3dSvg from './architecture3d/elements/balcony.svg';
export const BalconyArchitecture3d = (_p) => (<SVG svg={BalconyArchitecture3dSvg}/>);
import BathSvg from './architecture3d/elements/bath.svg';
export const Bath = (_p) => (<SVG svg={BathSvg}/>);
import ColumnSvg from './architecture3d/elements/column.svg';
export const Column = (_p) => (<SVG svg={ColumnSvg}/>);
import CurtainWallsSvg from './architecture3d/elements/curtainWalls.svg';
export const CurtainWalls = (_p) => (<SVG svg={CurtainWallsSvg}/>);
import DoorArchitecture3dSvg from './architecture3d/elements/door.svg';
export const DoorArchitecture3d = (_p) => (<SVG svg={DoorArchitecture3dSvg}/>);
import ElevatorSvg from './architecture3d/elements/elevator.svg';
export const Elevator = (_p) => (<SVG svg={ElevatorSvg}/>);
import EntryGroupSvg from './architecture3d/elements/entrygroup.svg';
export const EntryGroup = (_p) => (<SVG svg={EntryGroupSvg}/>);
import FloorSvg from './architecture3d/elements/floor.svg';
export const Floor = (_p) => (<SVG svg={FloorSvg}/>);
import FoundationArchitecture3dSvg from './architecture3d/elements/foundation.svg';
export const FoundationArchitecture3d = (_p) => (<SVG svg={FoundationArchitecture3dSvg}/>);
import RoofSvg from './architecture3d/elements/roof.svg';
export const Roof = (_p) => (<SVG svg={RoofSvg}/>);
import SlabsArchitecture3dSvg from './architecture3d/elements/slabs.svg';
export const SlabsArchitecture3d = (_p) => (<SVG svg={SlabsArchitecture3dSvg}/>);
import StairsSvg from './architecture3d/elements/stairs.svg';
export const Stairs = (_p) => (<SVG svg={StairsSvg}/>);
import SteelElementsSvg from './architecture3d/elements/steel elements.svg';
export const SteelElements = (_p) => (<SVG svg={SteelElementsSvg}/>);
import SteelJointsSvg from './architecture3d/elements/steelJoints.svg';
export const SteelJoints = (_p) => (<SVG svg={SteelJointsSvg}/>);
import WallArchitecture3dSvg from './architecture3d/elements/wall.svg';
export const WallArchitecture3d = (_p) => (<SVG svg={WallArchitecture3dSvg}/>);
import WindowSvg from './architecture3d/elements/window.svg';
export const Window = (_p) => (<SVG svg={WindowSvg}/>);
import FireResistanceSvg from './architecture3d/Fire resistance.svg';
export const FireResistance = (_p) => (<SVG svg={FireResistanceSvg}/>);
import FlightWidthSvg from './architecture3d/flightwidth.svg';
export const FlightWidth = (_p) => (<SVG svg={FlightWidthSvg}/>);
import GlazzedAreaSvg from './architecture3d/Glazzed area.svg';
export const GlazzedArea = (_p) => (<SVG svg={GlazzedAreaSvg}/>);
import HeightArchitecture3dSvg from './architecture3d/Height.svg';
export const HeightArchitecture3d = (_p) => (<SVG svg={HeightArchitecture3dSvg}/>);
import LandingWidthSvg from './architecture3d/landingwidth.svg';
export const LandingWidth = (_p) => (<SVG svg={LandingWidthSvg}/>);
import LeavesSvg from './architecture3d/leaves.svg';
export const Leaves = (_p) => (<SVG svg={LeavesSvg}/>);
import LengthArchitecture3dSvg from './architecture3d/Lenght.svg';
export const LengthArchitecture3d = (_p) => (<SVG svg={LengthArchitecture3dSvg}/>);
import MarkSvg from './architecture3d/Mark.svg';
export const Mark = (_p) => (<SVG svg={MarkSvg}/>);
import MaterialSvg from './architecture3d/Material.svg';
export const Material = (_p) => (<SVG svg={MaterialSvg}/>);
import NoStructureSvg from './architecture3d/Nostructure.svg';
export const NoStructure = (_p) => (<SVG svg={NoStructureSvg}/>);
import OpeningAreaSvg from './architecture3d/openingarea.svg';
export const OpeningArea = (_p) => (<SVG svg={OpeningAreaSvg}/>);
import OrientationSvg from './architecture3d/Orientation.svg';
export const Orientation = (_p) => (<SVG svg={OrientationSvg}/>);
import PanelNumberSvg from './architecture3d/Panel Number.svg';
export const PanelNumber = (_p) => (<SVG svg={PanelNumberSvg}/>);
import PerimeterArchitecture3dSvg from './architecture3d/Perimetr.svg';
export const PerimeterArchitecture3d = (_p) => (<SVG svg={PerimeterArchitecture3dSvg}/>);
import PipetteSvg from './architecture3d/pipette.svg';
export const Pipette = (_p) => (<SVG svg={PipetteSvg}/>);
import SoundTransmissionSvg from './architecture3d/Sound transmission.svg';
export const SoundTransmission = (_p) => (<SVG svg={SoundTransmissionSvg}/>);
import StepDimensionsSvg from './architecture3d/Step dimensions.svg';
export const StepDimensions = (_p) => (<SVG svg={StepDimensionsSvg}/>);
import StructurAarchitecture3dSvg from './architecture3d/Structure.svg';
export const StructurAarchitecture3d = (_p) => (<SVG svg={StructurAarchitecture3dSvg}/>);
import ThermalTransmittanceSvg from './architecture3d/Thermal transmittance.svg';
export const ThermalTransmittance = (_p) => (<SVG svg={ThermalTransmittanceSvg}/>);
import ThicknessSvg from './architecture3d/Thickness.svg';
export const Thickness = (_p) => (<SVG svg={ThicknessSvg}/>);
import TypeArchitecture3dSvg from './architecture3d/Type.svg';
export const TypeArchitecture3d = (_p) => (<SVG svg={TypeArchitecture3dSvg}/>);
import WidthFlightSvg from './architecture3d/Width flight.svg';
export const WidthFlight = (_p) => (<SVG svg={WidthFlightSvg}/>);
import WidthLandingSvg from './architecture3d/Width Landing.svg';
export const WidthLanding = (_p) => (<SVG svg={WidthLandingSvg}/>);
import WidthArchitecture3dSvg from './architecture3d/Width.svg';
export const WidthArchitecture3d = (_p) => (<SVG svg={WidthArchitecture3dSvg}/>);
import ArrowSvg from './common/arrow.svg';
export const Arrow = (_p) => (<SVG svg={ArrowSvg}/>);
import Arrow45degSvg from './common/arrow45deg.svg';
export const Arrow45deg = (_p) => (<SVG svg={Arrow45degSvg}/>);
import AssembliesSvg from './common/assemblies.svg';
export const Assemblies = (_p) => (<SVG svg={AssembliesSvg}/>);
import BSvg from './common/B.svg';
export const B = (_p) => (<SVG svg={BSvg}/>);
import BackSvg from './common/back.svg';
export const Back = (_p) => (<SVG svg={BackSvg}/>);
import BadSvg from './common/bad.svg';
export const Bad = (_p) => (<SVG svg={BadSvg}/>);
import BeamsSvg from './common/beams.svg';
export const Beams = (_p) => (<SVG svg={BeamsSvg}/>);
import BellSvg from './common/bell.svg';
export const Bell = (_p) => (<SVG svg={BellSvg}/>);
import BookmarkSvg from './common/bookmark.svg';
export const Bookmark = (_p) => (<SVG svg={BookmarkSvg}/>);
import BookmarkFilledSvg from './common/bookmark_filled.svg';
export const BookmarkFilled = (_p) => (<SVG svg={BookmarkFilledSvg}/>);
import BracesSvg from './common/braces.svg';
export const Braces = (_p) => (<SVG svg={BracesSvg}/>);
import BrushSvg from './common/brush.svg';
export const Brush = (_p) => (<SVG svg={BrushSvg}/>);
import BrushSmallSvg from './common/brush_small.svg';
export const BrushSmall = (_p) => (<SVG svg={BrushSmallSvg}/>);
import CalculateSvg from './common/calculate.svg';
export const Calculate = (_p) => (<SVG svg={CalculateSvg}/>);
import CalibrateSvg from './common/calibrate.svg';
export const Calibrate = (_p) => (<SVG svg={CalibrateSvg}/>);
import CalendarSvg from './common/calendar.svg';
export const Calendar = (_p) => (<SVG svg={CalendarSvg}/>);
import CamcoderSvg from './common/camcoder.svg';
export const Camcoder = (_p) => (<SVG svg={CamcoderSvg}/>);
import CameraSvg from './common/camera.svg';
export const Camera = (_p) => (<SVG svg={CameraSvg}/>);
import ChatSvg from './common/chat.svg';
export const Chat = (_p) => (<SVG svg={ChatSvg}/>);
import ChromeLogoSvg from './common/chrome-logo.svg';
export const ChromeLogo = (_p) => (<SVG svg={ChromeLogoSvg}/>);
import CircleFilledSvg from './common/circle-filled.svg';
export const CircleFilled = (_p) => (<SVG svg={CircleFilledSvg}/>);
import CitySvg from './common/City.svg';
export const City = (_p) => (<SVG svg={CitySvg}/>);
import ClockSvg from './common/clock.svg';
export const Clock = (_p) => (<SVG svg={ClockSvg}/>);
import CloseSvg from './common/close.svg';
export const Close = (_p) => (<SVG svg={CloseSvg}/>);
import CloseSmallSvg from './common/close_small.svg';
export const CloseSmall = (_p) => (<SVG svg={CloseSmallSvg}/>);
import CloseOtherSvg from './common/close-other.svg';
export const CloseOther = (_p) => (<SVG svg={CloseOtherSvg}/>);
import CloudSvg from './common/cloud.svg';
export const Cloud = (_p) => (<SVG svg={CloudSvg}/>);
import CloudsSvg from './common/clouds.svg';
export const Clouds = (_p) => (<SVG svg={CloudsSvg}/>);
import ColumnsSvg from './common/colums.svg';
export const Columns = (_p) => (<SVG svg={ColumnsSvg}/>);
import CombineSvg from './common/combine.svg';
export const Combine = (_p) => (<SVG svg={CombineSvg}/>);
import CommentSvg from './common/comment.svg';
export const Comment = (_p) => (<SVG svg={CommentSvg}/>);
import CompanySvg from './common/company.svg';
export const Company = (_p) => (<SVG svg={CompanySvg}/>);
import CompareSvg from './common/compare.svg';
export const Compare = (_p) => (<SVG svg={CompareSvg}/>);
import CompassMarkupSvg from './common/compass_markup.svg';
export const CompassMarkup = (_p) => (<SVG svg={CompassMarkupSvg}/>);
import ConcreteBigSvg from './common/concrete-big.svg';
export const ConcreteBig = (_p) => (<SVG svg={ConcreteBigSvg}/>);
import ConcreteSvg from './common/concrete.svg';
export const Concrete = (_p) => (<SVG svg={ConcreteSvg}/>);
import ConcreteNewSvg from './common/CONCRETE_new.svg';
export const ConcreteNew = (_p) => (<SVG svg={ConcreteNewSvg}/>);
import ApproximateCostSvg from './costs/approximate.svg';
export const ApproximateCost = (_p) => (<SVG svg={ApproximateCostSvg}/>);
import PercentageCostSvg from './costs/percentage.svg';
export const PercentageCost = (_p) => (<SVG svg={PercentageCostSvg}/>);
import CostsSvg from './common/costs.svg';
export const Costs = (_p) => (<SVG svg={CostsSvg}/>);
import CountryFlagSvg from './common/country-flag.svg';
export const CountryFlag = (_p) => (<SVG svg={CountryFlagSvg}/>);
import CountrySvg from './common/Country.svg';
export const Country = (_p) => (<SVG svg={CountrySvg}/>);
import BuildingTypeSvg from './create-project/building_type.svg';
export const BuildingType = (_p) => (<SVG svg={BuildingTypeSvg}/>);
import FrameSvg from './create-project/frame.svg';
export const Frame = (_p) => (<SVG svg={FrameSvg}/>);
import HeightFloorSvg from './create-project/heightfloor.svg';
export const HeightFloor = (_p) => (<SVG svg={HeightFloorSvg}/>);
import NameCreateProjectSvg from './create-project/name.svg';
export const NameCreateProject = (_p) => (<SVG svg={NameCreateProjectSvg}/>);
import NumbersSvg from './create-project/numbers.svg';
export const Numbers = (_p) => (<SVG svg={NumbersSvg}/>);
import CreateSvg from './common/create.svg';
export const Create = (_p) => (<SVG svg={CreateSvg}/>);
import CreateFilterSvg from './common/createfilter.svg';
export const CreateFilter = (_p) => (<SVG svg={CreateFilterSvg}/>);
import CreditCardSvg from './common/credit-card.svg';
export const CreditCard = (_p) => (<SVG svg={CreditCardSvg}/>);
import DashboardSvg from './common/dashboard.svg';
export const Dashboard = (_p) => (<SVG svg={DashboardSvg}/>);
import DataSvg from './common/data.svg';
export const Data = (_p) => (<SVG svg={DataSvg}/>);
import DeclineSvg from './common/decline.svg';
export const Decline = (_p) => (<SVG svg={DeclineSvg}/>);
import DefaultSvg from './common/default.svg';
export const Default = (_p) => (<SVG svg={DefaultSvg}/>);
import DemoProjectSvg from './common/demoproject.svg';
export const DemoProject = (_p) => (<SVG svg={DemoProjectSvg}/>);
import DeselectAllSvg from './common/deselect-all.svg';
export const DeselectAll = (_p) => (<SVG svg={DeselectAllSvg}/>);
import DistrictSvg from './common/district.svg';
export const District = (_p) => (<SVG svg={DistrictSvg}/>);
import DoneSvg from './common/done.svg';
export const Done = (_p) => (<SVG svg={DoneSvg}/>);
import DownloadIconSvg from './common/dowload_icon.svg';
export const DownloadIcon = (_p) => (<SVG svg={DownloadIconSvg}/>);
import DownloadAllSvg from './common/download-all.svg';
export const DownloadAll = (_p) => (<SVG svg={DownloadAllSvg}/>);
import DownloadSvg from './common/download.svg';
export const Download = (_p) => (<SVG svg={DownloadSvg}/>);
import DuplicateSvg from './common/duplicate.svg';
export const Duplicate = (_p) => (<SVG svg={DuplicateSvg}/>);
import EcologySvg from './common/ecology.svg';
export const Ecology = (_p) => (<SVG svg={EcologySvg}/>);
import EditSvg from './common/edit.svg';
export const Edit = (_p) => (<SVG svg={EditSvg}/>);
import SmallEditSvg from './common/small-edit.svg';
export const SmallEdit = (_p) => (<SVG svg={SmallEditSvg}/>);
import EmailSvg from './common/email.svg';
export const Email = (_p) => (<SVG svg={EmailSvg}/>);
import ErrorSvg from './common/error.svg';
export const Error = (_p) => (<SVG svg={ErrorSvg}/>);
import ExitSvg from './common/exit.svg';
export const Exit = (_p) => (<SVG svg={ExitSvg}/>);
import ExportSvg from './common/export.svg';
export const Export = (_p) => (<SVG svg={ExportSvg}/>);
import ExternalSvg from './common/external.svg';
export const External = (_p) => (<SVG svg={ExternalSvg}/>);
import EyeSvg from './common/eye.svg';
export const Eye = (_p) => (<SVG svg={EyeSvg}/>);
import FSvg from './common/F.svg';
export const F = (_p) => (<SVG svg={FSvg}/>);
import FavouritesSvg from './common/favourites.svg';
export const Favourites = (_p) => (<SVG svg={FavouritesSvg}/>);
import FilterSvg from './common/filter.svg';
export const Filter = (_p) => (<SVG svg={FilterSvg}/>);
import FiltersSvg from './common/filters.svg';
export const Filters = (_p) => (<SVG svg={FiltersSvg}/>);
import FilterNumberSvg from './common/filter_number.svg';
export const FilterNumber = (_p) => (<SVG svg={FilterNumberSvg}/>);
import FinishSvg from './common/finish.svg';
export const Finish = (_p) => (<SVG svg={FinishSvg}/>);
import FlagSvg from './common/flag.svg';
export const Flag = (_p) => (<SVG svg={FlagSvg}/>);
import FloorHeightSvg from './common/floorHeight.svg';
export const FloorHeight = (_p) => (<SVG svg={FloorHeightSvg}/>);
import FloorPlansSvg from './common/floorplans.svg';
export const FloorPlans = (_p) => (<SVG svg={FloorPlansSvg}/>);
import FloorsNumberSvg from './common/floorsNumber.svg';
export const FloorsNumber = (_p) => (<SVG svg={FloorsNumberSvg}/>);
import FocusSvg from './common/focus.svg';
export const Focus = (_p) => (<SVG svg={FocusSvg}/>);
import FolderSvg from './common/folder.svg';
export const Folder = (_p) => (<SVG svg={FolderSvg}/>);
import FoldersSvg from './common/folders.svg';
export const Folders = (_p) => (<SVG svg={FoldersSvg}/>);
import FormulaSvg from './common/formula.svg';
export const Formula = (_p) => (<SVG svg={FormulaSvg}/>);
import FoundationSvg from './common/foundation.svg';
export const Foundation = (_p) => (<SVG svg={FoundationSvg}/>);
import FoundationsSvg from './common/foundations.svg';
export const Foundations = (_p) => (<SVG svg={FoundationsSvg}/>);
import FrameCreateProjectSvg from './common/frame.svg';
export const FrameCreateProject = (_p) => (<SVG svg={FrameCreateProjectSvg}/>);
import ConcreteFramesSvg from './frames/concrete.svg';
export const ConcreteFrames = (_p) => (<SVG svg={ConcreteFramesSvg}/>);
import ModularSvg from './frames/modular.svg';
export const Modular = (_p) => (<SVG svg={ModularSvg}/>);
import SteelFramesSvg from './frames/steel.svg';
export const SteelFrames = (_p) => (<SVG svg={SteelFramesSvg}/>);
import WoodSvg from './frames/wood.svg';
export const Wood = (_p) => (<SVG svg={WoodSvg}/>);
import WoodSSvg from './frames/wood_s.svg';
export const WoodS = (_p) => (<SVG svg={WoodSSvg}/>);
import FullScreenSvg from './common/full-screen.svg';
export const FullScreen = (_p) => (<SVG svg={FullScreenSvg}/>);
import GallerySvg from './common/gallery.svg';
export const Gallery = (_p) => (<SVG svg={GallerySvg}/>);
import GearSvg from './common/gear.svg';
export const Gear = (_p) => (<SVG svg={GearSvg}/>);
import GoogleSvg from './common/google.svg';
export const Google = (_p) => (<SVG svg={GoogleSvg}/>);
import HandSvg from './common/hand.svg';
export const Hand = (_p) => (<SVG svg={HandSvg}/>);
import HappySvg from './common/happy.svg';
export const Happy = (_p) => (<SVG svg={HappySvg}/>);
import HelpSvg from './common/help.svg';
export const Help = (_p) => (<SVG svg={HelpSvg}/>);
import HiddenObjectsSvg from './common/hiddenobjects.svg';
export const HiddenObjects = (_p) => (<SVG svg={HiddenObjectsSvg}/>);
import HideSvg from './common/hide.svg';
export const Hide = (_p) => (<SVG svg={HideSvg}/>);
import HomeSvg from './common/home.svg';
export const Home = (_p) => (<SVG svg={HomeSvg}/>);
import HorizontalMenuSvg from './common/horizontalmenu.svg';
export const HorizontalMenu = (_p) => (<SVG svg={HorizontalMenuSvg}/>);
import IconDownloadSvg from './common/icon_dowload.svg';
export const IconDownload = (_p) => (<SVG svg={IconDownloadSvg}/>);
import IconEmailSentSvg from './common/icon_email_sent.svg';
export const IconEmailSent = (_p) => (<SVG svg={IconEmailSentSvg}/>);
import ImageTransparentSvg from './common/image.svg';
export const ImageTransparent = (_p) => (<SVG svg={ImageTransparentSvg}/>);
import ImportSvg from './common/import.svg';
export const Import = (_p) => (<SVG svg={ImportSvg}/>);
import IndSvg from './common/ind.svg';
export const Ind = (_p) => (<SVG svg={IndSvg}/>);
import InfoSvg from './common/info.svg';
export const Info = (_p) => (<SVG svg={InfoSvg}/>);
import InternalSvg from './common/internal.svg';
export const Internal = (_p) => (<SVG svg={InternalSvg}/>);
import InvalidSvg from './common/invalid.svg';
export const Invalid = (_p) => (<SVG svg={InvalidSvg}/>);
import InverseSvg from './common/inverse.svg';
export const Inverse = (_p) => (<SVG svg={InverseSvg}/>);
import InvisibleSvg from './common/invisible.svg';
export const Invisible = (_p) => (<SVG svg={InvisibleSvg}/>);
import IsolateSvg from './common/isolate.svg';
export const Isolate = (_p) => (<SVG svg={IsolateSvg}/>);
import JobRoleSvg from './common/jobrole.svg';
export const JobRole = (_p) => (<SVG svg={JobRoleSvg}/>);
import KeyboardSvg from './common/keyboard.svg';
export const Keyboard = (_p) => (<SVG svg={KeyboardSvg}/>);
import KeysSvg from './common/keys.svg';
export const Keys = (_p) => (<SVG svg={KeysSvg}/>);
import LeftMarkSvg from './common/left-mark.svg';
export const LeftMark = (_p) => (<SVG svg={LeftMarkSvg}/>);
import LinkSvg from './common/link.svg';
export const Link = (_p) => (<SVG svg={LinkSvg}/>);
import LinkedinSvg from './common/linkedin.svg';
export const Linkedin = (_p) => (<SVG svg={LinkedinSvg}/>);
import LinkArrowSvg from './common/link_arrow.svg';
export const LinkArrow = (_p) => (<SVG svg={LinkArrowSvg}/>);
import LoaderSvg from './common/loader.svg';
export const Loader = (_p) => (<SVG svg={LoaderSvg}/>);
import LevelSvg from './loads/level.svg';
export const Level = (_p) => (<SVG svg={LevelSvg}/>);
import SnowSvg from './loads/snow.svg';
export const Snow = (_p) => (<SVG svg={SnowSvg}/>);
import WindSvg from './loads/wind.svg';
export const Wind = (_p) => (<SVG svg={WindSvg}/>);
import LoadsSvg from './common/loads.svg';
export const Loads = (_p) => (<SVG svg={LoadsSvg}/>);
import LockedSvg from './common/locked.svg';
export const Locked = (_p) => (<SVG svg={LockedSvg}/>);
import DesignLogoSvg from './logos/design_logo.svg';
export const DesignLogo = (_p) => (<SVG svg={DesignLogoSvg}/>);
import KreoLogoSvg from './logos/Kreologo.svg';
export const KreoLogo = (_p) => (<SVG svg={KreoLogoSvg}/>);
import LogoSvg from './logos/logo.svg';
export const Logo = (_p) => (<SVG svg={LogoSvg}/>);
import LogoDarkSvg from './logos/logo_dark.svg';
export const LogoDark = (_p) => (<SVG svg={LogoDarkSvg}/>);
import LogoLightSvg from './logos/logo_light.svg';
export const LogoLight = (_p) => (<SVG svg={LogoLightSvg}/>);
import ModularLogoSvg from './logos/modular_logo.svg';
export const ModularLogo = (_p) => (<SVG svg={ModularLogoSvg}/>);
import SkemaLogoSvg from './logos/skema_logo.svg';
export const SkemaLogo = (_p) => (<SVG svg={SkemaLogoSvg}/>);
import SkemaWithNameLogoSvg from './logos/skema_logo_with_name.svg';
export const SkemaWithNameLogo = (_p) => (<SVG svg={SkemaWithNameLogoSvg}/>);
import SeLogoSvg from './logos/se-logo.svg';
export const SeLogo = (_p) => (<SVG svg={SeLogoSvg}/>);
import VisualBriefLogoSvg from './logos/visual_brief_logo.svg';
export const VisualBriefLogo = (_p) => (<SVG svg={VisualBriefLogoSvg}/>);
import TakeOffLogoSvg from './logos/takeoff.svg';
export const TakeOffLogo = (_p) => (<SVG svg={TakeOffLogoSvg}/>);
import TakeOffIconSvg from './logos/takeoff_icon.svg';
export const TakeOffIcon = (_p) => (<SVG svg={TakeOffIconSvg}/>);
import TwoDSvg from './map/2d.svg';
export const TwoD = (_p) => (<SVG svg={TwoDSvg}/>);
import ThreeDSvg from './map/3d.svg';
export const ThreeD = (_p) => (<SVG svg={ThreeDSvg}/>);
import AngleSvg from './map/angle.svg';
export const Angle = (_p) => (<SVG svg={AngleSvg}/>);
import ConstructionSiteSvg from './map/construction-site.svg';
export const ConstructionSite = (_p) => (<SVG svg={ConstructionSiteSvg}/>);
import DiameterSvg from './map/diameter.svg';
export const Diameter = (_p) => (<SVG svg={DiameterSvg}/>);
import DisconnectSvg from './map/disconnect.svg';
export const Disconnect = (_p) => (<SVG svg={DisconnectSvg}/>);
import FlipHorizontalSvg from './map/flipHorizontal.svg';
export const FlipHorizontal = (_p) => (<SVG svg={FlipHorizontalSvg}/>);
import FlipVerticalSvg from './map/flipVertical.svg';
export const FlipVertical = (_p) => (<SVG svg={FlipVerticalSvg}/>);
import GraphSvg from './map/graph.svg';
export const Graph = (_p) => (<SVG svg={GraphSvg}/>);
import GraphSiteSvg from './map/graphsite.svg';
export const GraphSite = (_p) => (<SVG svg={GraphSiteSvg}/>);
import GridSvg from './map/grid.svg';
export const Grid = (_p) => (<SVG svg={GridSvg}/>);
import HeightSvg from './map/height.svg';
export const Height = (_p) => (<SVG svg={HeightSvg}/>);
import InputDataSvg from './map/input_data.svg';
export const InputData = (_p) => (<SVG svg={InputDataSvg}/>);
import LayersMapSvg from './map/layers_map.svg';
export const LayersMap = (_p) => (<SVG svg={LayersMapSvg}/>);
import LengthSvg from './map/length.svg';
export const Length = (_p) => (<SVG svg={LengthSvg}/>);
import ModifySvg from './map/modify.svg';
export const Modify = (_p) => (<SVG svg={ModifySvg}/>);
import OtherSvg from './map/other.svg';
export const Other = (_p) => (<SVG svg={OtherSvg}/>);
import PerimeterSvg from './map/perimeter.svg';
export const Perimeter = (_p) => (<SVG svg={PerimeterSvg}/>);
import PolygonMapSvg from './map/polygon.svg';
export const PolygonMap = (_p) => (<SVG svg={PolygonMapSvg}/>);
import VoronoiSvg from './map/voronoi.svg';
export const Voronoi = (_p) => (<SVG svg={VoronoiSvg}/>);
import WidthSvg from './map/width.svg';
export const Width = (_p) => (<SVG svg={WidthSvg}/>);
import MapMode16pxSvg from './common/mapmode16px.svg';
export const MapMode16px = (_p) => (<SVG svg={MapMode16pxSvg}/>);
import MarkerSvg from './common/marker.svg';
export const Marker = (_p) => (<SVG svg={MarkerSvg}/>);
import MenuBurgerSvg from './common/menu-burger.svg';
export const MenuBurger = (_p) => (<SVG svg={MenuBurgerSvg}/>);
import MenuBurgerVariableSvg from './common/menu-burger-variable.svg';
export const MenuBurgerVariable = (_p) => (<SVG svg={MenuBurgerVariableSvg}/>);
import MenuSvg from './common/menu.svg';
export const Menu = (_p) => (<SVG svg={MenuSvg}/>);
import MepSvg from './common/mep.svg';
export const Mep = (_p) => (<SVG svg={MepSvg}/>);
import MinusSvg from './common/minus.svg';
export const Minus = (_p) => (<SVG svg={MinusSvg}/>);
import MinusBigSvg from './common/minus_big.svg';
export const MinusBig = (_p) => (<SVG svg={MinusBigSvg}/>);
import ModularBigSvg from './common/modular-big.svg';
export const ModularBig = (_p) => (<SVG svg={ModularBigSvg}/>);
import ModularsSvg from './common/modulars.svg';
export const Modulars = (_p) => (<SVG svg={ModularsSvg}/>);
import MoonSvg from './common/moon.svg';
export const Moon = (_p) => (<SVG svg={MoonSvg}/>);
import MouseSvg from './common/mouse.svg';
export const Mouse = (_p) => (<SVG svg={MouseSvg}/>);
import MoveToFolderSvg from './common/move-to-folder.svg';
export const MoveToFolder = (_p) => (<SVG svg={MoveToFolderSvg}/>);
import NameSvg from './common/name.svg';
export const Name = (_p) => (<SVG svg={NameSvg}/>);
import NavSvg from './common/nav.svg';
export const Nav = (_p) => (<SVG svg={NavSvg}/>);
import Nav4Svg from './common/nav4.svg';
export const Nav4 = (_p) => (<SVG svg={Nav4Svg}/>);
import NewSvg from './common/new.svg';
export const New = (_p) => (<SVG svg={NewSvg}/>);
import NewFilterFromThisSvg from './common/newfilterfromthis.svg';
export const NewFilterFromThis = (_p) => (<SVG svg={NewFilterFromThisSvg}/>);
import NewFromThisSvg from './common/newfromthis.svg';
export const NewFromThis = (_p) => (<SVG svg={NewFromThisSvg}/>);
import NewProjectSvg from './common/newproject.svg';
export const NewProject = (_p) => (<SVG svg={NewProjectSvg}/>);
import NoSvg from './common/no.svg';
export const No = (_p) => (<SVG svg={NoSvg}/>);
import NoResultSvg from './common/noresult.svg';
export const NoResult = (_p) => (<SVG svg={NoResultSvg}/>);
import OneSvg from './numbers/1.svg';
export const One = (_p) => (<SVG svg={OneSvg}/>);
import TwoSvg from './numbers/2.svg';
export const Two = (_p) => (<SVG svg={TwoSvg}/>);
import ThreeSvg from './numbers/3.svg';
export const Three = (_p) => (<SVG svg={ThreeSvg}/>);
import FourSvg from './numbers/4.svg';
export const Four = (_p) => (<SVG svg={FourSvg}/>);
import OfficeBigSvg from './common/office-big.svg';
export const OfficeBig = (_p) => (<SVG svg={OfficeBigSvg}/>);
import OfficeNewSvg from './common/office_new.svg';
export const OfficeNew = (_p) => (<SVG svg={OfficeNewSvg}/>);
import BrashSvg from './common/paintedobjects.svg';
export const Brash = (_p) => (<SVG svg={BrashSvg}/>);
import PaintedObjectsSvg from './common/paintedobjetcs.svg';
export const PaintedObjects = (_p) => (<SVG svg={PaintedObjectsSvg}/>);
import PaintObjectsSmallSvg from './common/paintobjects_small.svg';
export const PaintObjectsSmall = (_p) => (<SVG svg={PaintObjectsSmallSvg}/>);
import PaletteSvg from './common/palette.svg';
export const Palette = (_p) => (<SVG svg={PaletteSvg}/>);
import ParallelSvg from './common/paralell.svg';
export const Parallel = (_p) => (<SVG svg={ParallelSvg}/>);
import PasswordSvg from './common/password.svg';
export const Password = (_p) => (<SVG svg={PasswordSvg}/>);
import PasswordResetSvg from './common/password_reset.svg';
export const PasswordReset = (_p) => (<SVG svg={PasswordResetSvg}/>);
import PatternSvg from './common/pattern.svg';
export const Pattern = (_p) => (<SVG svg={PatternSvg}/>);
import AmericanExpressSvg from './payment/american-express.svg';
export const AmericanExpress = (_p) => (<SVG svg={AmericanExpressSvg}/>);
import PaymentDefaultSvg from './payment/default.svg';
export const PaymentDefault = (_p) => (<SVG svg={PaymentDefaultSvg}/>);
import DinersClubSvg from './payment/diners-club.svg';
export const DinersClub = (_p) => (<SVG svg={DinersClubSvg}/>);
import DiscoverSvg from './payment/discover.svg';
export const Discover = (_p) => (<SVG svg={DiscoverSvg}/>);
import EloSvg from './payment/elo.svg';
export const Elo = (_p) => (<SVG svg={EloSvg}/>);
import HipercardSvg from './payment/hipercard.svg';
export const Hipercard = (_p) => (<SVG svg={HipercardSvg}/>);
import JcbSvg from './payment/jcb.svg';
export const Jcb = (_p) => (<SVG svg={JcbSvg}/>);
import MaestroSvg from './payment/maestro.svg';
export const Maestro = (_p) => (<SVG svg={MaestroSvg}/>);
import MastercardSvg from './payment/mastercard.svg';
export const Mastercard = (_p) => (<SVG svg={MastercardSvg}/>);
import UnionPaySvg from './payment/unionpay.svg';
export const UnionPay = (_p) => (<SVG svg={UnionPaySvg}/>);
import VisaSvg from './payment/visa.svg';
export const Visa = (_p) => (<SVG svg={VisaSvg}/>);
import PerspectiveSvg from './common/perspective.svg';
export const Perspective = (_p) => (<SVG svg={PerspectiveSvg}/>);
import PhoneSvg from './common/phone.svg';
export const Phone = (_p) => (<SVG svg={PhoneSvg}/>);
import PileCapsSvg from './common/pilecaps.svg';
export const PileCaps = (_p) => (<SVG svg={PileCapsSvg}/>);
import PinSvg from './common/pin.svg';
export const Pin = (_p) => (<SVG svg={PinSvg}/>);
import PipSvg from './common/pip.svg';
export const Pip = (_p) => (<SVG svg={PipSvg}/>);
import PlanSvg from './common/plan.svg';
export const Plan = (_p) => (<SVG svg={PlanSvg}/>);
import PlaySvg from './common/play.svg';
export const Play = (_p) => (<SVG svg={PlaySvg}/>);
import PlusBigSvg from './common/plus_big.svg';
export const PlusBig = (_p) => (<SVG svg={PlusBigSvg}/>);
import PlusSmallSvg from './common/plus_small.svg';
export const PlusSmall = (_p) => (<SVG svg={PlusSmallSvg}/>);
import PolygonSvg from './common/polygon.svg';
export const Polygon = (_p) => (<SVG svg={PolygonSvg}/>);
import PrecastSvg from './common/precast.svg';
export const Precast = (_p) => (<SVG svg={PrecastSvg}/>);
import ProfileSvg from './common/profile.svg';
export const Profile = (_p) => (<SVG svg={ProfileSvg}/>);
import ArchitectureProjectDetailsSvg from './project-details/architecture.svg';
export const ArchitectureProjectDetails = (_p) => (<SVG svg={ArchitectureProjectDetailsSvg}/>);
import ConstructionSvg from './project-details/construction.svg';
export const Construction = (_p) => (<SVG svg={ConstructionSvg}/>);
import ElecSvg from './project-details/elec.svg';
export const Elec = (_p) => (<SVG svg={ElecSvg}/>);
import FloorPlanProjectDetailsSvg from './project-details/floorplan.svg';
export const FloorPlanProjectDetails = (_p) => (<SVG svg={FloorPlanProjectDetailsSvg}/>);
import FormworkSvg from './project-details/formwork.svg';
export const Formwork = (_p) => (<SVG svg={FormworkSvg}/>);
import HeatingSvg from './project-details/heating.svg';
export const Heating = (_p) => (<SVG svg={HeatingSvg}/>);
import ModelSvg from './project-details/model.svg';
export const Model = (_p) => (<SVG svg={ModelSvg}/>);
import ReportsProjectDetailsSvg from './project-details/reports.svg';
export const ReportsProjectDetails = (_p) => (<SVG svg={ReportsProjectDetailsSvg}/>);
import SchemeSvg from './project-details/scheme.svg';
export const Scheme = (_p) => (<SVG svg={SchemeSvg}/>);
import StructureProjectDetailsSvg from './project-details/structure.svg';
export const StructureProjectDetails = (_p) => (<SVG svg={StructureProjectDetailsSvg}/>);
import ProjectSvg from './common/project.svg';
export const Project = (_p) => (<SVG svg={ProjectSvg}/>);
import ProjectsSvg from './common/projects.svg';
export const Projects = (_p) => (<SVG svg={ProjectsSvg}/>);
import PropertiesSvg from './common/properties.svg';
export const Properties = (_p) => (<SVG svg={PropertiesSvg}/>);
import ProtectSvg from './common/protect.svg';
export const Protect = (_p) => (<SVG svg={ProtectSvg}/>);
import QuestionSSvg from './common/question-s.svg';
export const QuestionS = (_p) => (<SVG svg={QuestionSSvg}/>);
import QuestionSvg from './common/question.svg';
export const Question = (_p) => (<SVG svg={QuestionSvg}/>);
import RandomSvg from './common/random.svg';
export const Random = (_p) => (<SVG svg={RandomSvg}/>);
import RecalculateBigSvg from './common/recalculate-big.svg';
export const RecalculateBig = (_p) => (<SVG svg={RecalculateBigSvg}/>);
import RecalculateSvg from './common/recalculate.svg';
export const Recalculate = (_p) => (<SVG svg={RecalculateSvg}/>);
import RectangleSvg from './common/rectangle.svg';
export const Rectangle = (_p) => (<SVG svg={RectangleSvg}/>);
import RedoSvg from './common/redo.svg';
export const Redo = (_p) => (<SVG svg={RedoSvg}/>);
import RedoClassicSvg from './common/redo-classic.svg';
export const RedoClassic = (_p) => (<SVG svg={RedoClassicSvg}/>);
import ReinforcementSvg from './common/reinforcement.svg';
export const Reinforcement = (_p) => (<SVG svg={ReinforcementSvg}/>);
import RemoveFromFolderSvg from './common/removefromfollder.svg';
export const RemoveFromFolder = (_p) => (<SVG svg={RemoveFromFolderSvg}/>);
import RepeatSvg from './common/repeat.svg';
export const Repeat = (_p) => (<SVG svg={RepeatSvg}/>);
import Reports2Svg from './common/reports-2.svg';
export const Reports2 = (_p) => (<SVG svg={Reports2Svg}/>);
import ReportsSvg from './common/reports.svg';
export const Reports = (_p) => (<SVG svg={ReportsSvg}/>);
import ResidentialSvg from './common/resedential.svg';
export const Residential = (_p) => (<SVG svg={ResidentialSvg}/>);
import ResetSvg from './common/reset.svg';
export const Reset = (_p) => (<SVG svg={ResetSvg}/>);
import ActiveSvg from './reusable/active.svg';
export const Active = (_p) => (<SVG svg={ActiveSvg}/>);
import ApplySSvg from './reusable/apply-s.svg';
export const ApplyS = (_p) => (<SVG svg={ApplySSvg}/>);
import IndeterminateSvg from './reusable/indeterminate.svg';
export const Indeterminate = (_p) => (<SVG svg={IndeterminateSvg}/>);
import ApplyXsSvg from './reusable/apply-xs.svg';
export const ApplyXs = (_p) => (<SVG svg={ApplyXsSvg}/>);
import ApplySvg from './reusable/apply.svg';
export const Apply = (_p) => (<SVG svg={ApplySvg}/>);
import BottomSvg from './reusable/bottom.svg';
export const Bottom = (_p) => (<SVG svg={BottomSvg}/>);
import DownSvg from './reusable/brushed-arrows/down.svg';
export const Down = (_p) => (<SVG svg={DownSvg}/>);
import LeftBrushedArrowSvg from './reusable/brushed-arrows/left.svg';
export const LeftBrushedArrow = (_p) => (<SVG svg={LeftBrushedArrowSvg}/>);
import CollapseSvg from './reusable/collapse.svg';
export const Collapse = (_p) => (<SVG svg={CollapseSvg}/>);
import CollapseAllSmallSvg from './reusable/collapse-all-small.svg';
export const CollapseAllSmall = (_p) => (<SVG svg={CollapseAllSmallSvg}/>);
import CtrlYSvg from './reusable/ctrly.svg';
export const CtrlY = (_p) => (<SVG svg={CtrlYSvg}/>);
import CtrlZSvg from './reusable/ctrlz.svg';
export const CtrlZ = (_p) => (<SVG svg={CtrlZSvg}/>);
import DectiveSvg from './reusable/deactive.svg';
export const Dective = (_p) => (<SVG svg={DectiveSvg}/>);
import DeleteSvg from './reusable/delete.svg';
export const Delete = (_p) => (<SVG svg={DeleteSvg}/>);
import DownSmallSSvg from './reusable/downsmall-s.svg';
export const DownSmallS = (_p) => (<SVG svg={DownSmallSSvg}/>);
import DownSmallSvg from './reusable/downsmall.svg';
export const DownSmall = (_p) => (<SVG svg={DownSmallSvg}/>);
import ExpandSvg from './reusable/expand.svg';
export const Expand = (_p) => (<SVG svg={ExpandSvg}/>);
import ExpandAllSmallSvg from './reusable/expand-all-small.svg';
export const ExpandAllSmall = (_p) => (<SVG svg={ExpandAllSmallSvg}/>);
import LeftSvg from './reusable/left.svg';
export const Left = (_p) => (<SVG svg={LeftSvg}/>);
import LeftSmallSvg from './reusable/leftsmall.svg';
export const LeftSmall = (_p) => (<SVG svg={LeftSmallSvg}/>);
import RightSvg from './reusable/right.svg';
export const Right = (_p) => (<SVG svg={RightSvg}/>);
import RightSmallXsSvg from './reusable/rightsmall-xs.svg';
export const RightSmallXs = (_p) => (<SVG svg={RightSmallXsSvg}/>);
import RightSmallSvg from './reusable/rightsmall.svg';
export const RightSmall = (_p) => (<SVG svg={RightSmallSvg}/>);
import SaveSvg from './reusable/save.svg';
export const Save = (_p) => (<SVG svg={SaveSvg}/>);
import SmallCloseSvg from './reusable/smallclose.svg';
export const SmallClose = (_p) => (<SVG svg={SmallCloseSvg}/>);
import SmallLeftSvg from './reusable/smallleft.svg';
export const SmallLeft = (_p) => (<SVG svg={SmallLeftSvg}/>);
import TemplatesReusableSvg from './reusable/templates.svg';
export const TemplatesReusable = (_p) => (<SVG svg={TemplatesReusableSvg}/>);
import TopSmallSvg from './reusable/topsmall.svg';
export const TopSmall = (_p) => (<SVG svg={TopSmallSvg}/>);
import UpSvg from './reusable/up.svg';
export const Up = (_p) => (<SVG svg={UpSvg}/>);
import RightMarkSvg from './common/right-mark.svg';
export const RightMark = (_p) => (<SVG svg={RightMarkSvg}/>);
import RocketSvg from './common/rocket.svg';
export const Rocket = (_p) => (<SVG svg={RocketSvg}/>);
import RulerSvg from './common/ruler.svg';
export const Ruler = (_p) => (<SVG svg={RulerSvg}/>);
import SadSvg from './common/sad.svg';
export const Sad = (_p) => (<SVG svg={SadSvg}/>);
import SavePositionSvg from './common/save-position.svg';
export const SavePosition = (_p) => (<SVG svg={SavePositionSvg}/>);
import ScaleSvg from './common/scale.svg';
export const Scale = (_p) => (<SVG svg={ScaleSvg}/>);
import CircleSvg from './scetchs/circle.svg';
export const Circle = (_p) => (<SVG svg={CircleSvg}/>);
import SteelSvg from './scetchs/steel.svg';
export const Steel = (_p) => (<SVG svg={SteelSvg}/>);
import TrubSvg from './scetchs/trub.svg';
export const Trub = (_p) => (<SVG svg={TrubSvg}/>);
import ScorecardSvg from './common/scorecard.svg';
export const Scorecard = (_p) => (<SVG svg={ScorecardSvg}/>);
import ScreenshotSvg from './common/screenshot.svg';
export const Screenshot = (_p) => (<SVG svg={ScreenshotSvg}/>);
import SearchSvg from './common/search.svg';
export const Search = (_p) => (<SVG svg={SearchSvg}/>);
import SelectAllSvg from './common/select-all.svg';
export const SelectAll = (_p) => (<SVG svg={SelectAllSvg}/>);
import SelectSimilarSvg from './common/selectsimilar.svg';
export const SelectSimilar = (_p) => (<SVG svg={SelectSimilarSvg}/>);
import SelectSimilarRoundSvg from './common/selectsimular.svg';
export const SelectSimilarRound = (_p) => (<SVG svg={SelectSimilarRoundSvg}/>);
import SendSvg from './common/send.svg';
export const Send = (_p) => (<SVG svg={SendSvg}/>);
import SettingSvg from './common/setting.svg';
export const Setting = (_p) => (<SVG svg={SettingSvg}/>);
import SettingsSvg from './common/settings.svg';
export const Settings = (_p) => (<SVG svg={SettingsSvg}/>);
import ShareSvg from './common/share.svg';
export const Share = (_p) => (<SVG svg={ShareSvg}/>);
import ShowSvg from './common/show.svg';
export const Show = (_p) => (<SVG svg={ShowSvg}/>);
import SignInSvg from './common/signin.svg';
export const SignIn = (_p) => (<SVG svg={SignInSvg}/>);
import SimilarSvg from './common/similar.svg';
export const Similar = (_p) => (<SVG svg={SimilarSvg}/>);
import SlabsSvg from './common/slabs.svg';
export const Slabs = (_p) => (<SVG svg={SlabsSvg}/>);
import SmallCompassSvg from './common/small-compass.svg';
export const SmallCompass = (_p) => (<SVG svg={SmallCompassSvg}/>);
import SmallArrowSvg from './common/small_arrow.svg';
export const SmallArrow = (_p) => (<SVG svg={SmallArrowSvg}/>);
import SnapSvg from './common/snap.svg';
export const Snap = (_p) => (<SVG svg={SnapSvg}/>);
import SpecificationSvg from './common/specification.svg';
export const Specification = (_p) => (<SVG svg={SpecificationSvg}/>);
import SquareSvg from './common/square.svg';
export const Square = (_p) => (<SVG svg={SquareSvg}/>);
import SquaresSvg from './common/squares.svg';
export const Squares = (_p) => (<SVG svg={SquaresSvg}/>);
import SquareThinSvg from './common/square_thin.svg';
export const SquareThin = (_p) => (<SVG svg={SquareThinSvg}/>);
import StaleSvg from './common/STALE.svg';
export const Stale = (_p) => (<SVG svg={StaleSvg}/>);
import StarSvg from './common/star.svg';
export const Star = (_p) => (<SVG svg={StarSvg}/>);
import SteelBigSvg from './common/steel-big.svg';
export const SteelBig = (_p) => (<SVG svg={SteelBigSvg}/>);
import SteelBeamsSvg from './common/steelbeams.svg';
export const SteelBeams = (_p) => (<SVG svg={SteelBeamsSvg}/>);
import SteelBracesSvg from './common/steelbraces.svg';
export const SteelBraces = (_p) => (<SVG svg={SteelBracesSvg}/>);
import SteelColumnsSvg from './common/steelcolumns.svg';
export const SteelColumns = (_p) => (<SVG svg={SteelColumnsSvg}/>);
import StoreysSvg from './common/storeys.svg';
export const Storeys = (_p) => (<SVG svg={StoreysSvg}/>);
import StructureSvg from './common/structure.svg';
export const Structure = (_p) => (<SVG svg={StructureSvg}/>);
import SuccessSvg from './common/success.svg';
export const Success = (_p) => (<SVG svg={SuccessSvg}/>);
import SunSvg from './common/sun.svg';
export const Sun = (_p) => (<SVG svg={SunSvg}/>);
import CompassDarkSvg from './sunlight/compass_dark.svg';
export const CompassDark = (_p) => (<SVG svg={CompassDarkSvg}/>);
import CompassLightSvg from './sunlight/compass_light.svg';
export const CompassLight = (_p) => (<SVG svg={CompassLightSvg}/>);
import SunriseSvg from './sunlight/sunrise.svg';
export const Sunrise = (_p) => (<SVG svg={SunriseSvg}/>);
import SunsetSvg from './sunlight/sunset.svg';
export const Sunset = (_p) => (<SVG svg={SunsetSvg}/>);
import SuppSvg from './common/supp.svg';
export const Supp = (_p) => (<SVG svg={SuppSvg}/>);
import TableSvg from './common/table.svg';
export const Table = (_p) => (<SVG svg={TableSvg}/>);
import TemplatesSvg from './common/templates.svg';
export const Templates = (_p) => (<SVG svg={TemplatesSvg}/>);
import ThinArrowSvg from './common/thinArrow.svg';
export const ThinArrow = (_p) => (<SVG svg={ThinArrowSvg}/>);
import ThumbSupSvg from './common/thumbsup.svg';
export const ThumbSup = (_p) => (<SVG svg={ThumbSupSvg}/>);
import TypeSvg from './common/type.svg';
export const Type = (_p) => (<SVG svg={TypeSvg}/>);
import UndoSvg from './common/undo.svg';
export const Undo = (_p) => (<SVG svg={UndoSvg}/>);
import UndoClassicSvg from './common/undo-classic.svg';
export const UndoClassic = (_p) => (<SVG svg={UndoClassicSvg}/>);
import UnGroupSvg from './common/ungroup.svg';
export const UnGroup = (_p) => (<SVG svg={UnGroupSvg}/>);
import BalconySvg from './unit-editor/balcony.svg';
export const Balcony = (_p) => (<SVG svg={BalconySvg}/>);
import BlockSvg from './unit-editor/block.svg';
export const Block = (_p) => (<SVG svg={BlockSvg}/>);
import BlocksSvg from './unit-editor/blocks.svg';
export const Blocks = (_p) => (<SVG svg={BlocksSvg}/>);
import CoresSvg from './unit-editor/cores.svg';
export const Cores = (_p) => (<SVG svg={CoresSvg}/>);
import DoorSvg from './unit-editor/door.svg';
export const Door = (_p) => (<SVG svg={DoorSvg}/>);
import EntranceSvg from './unit-editor/entrance.svg';
export const Entrance = (_p) => (<SVG svg={EntranceSvg}/>);
import ModulesVerticalSvg from './unit-editor/modules-vertical.svg';
export const ModulesVertical = (_p) => (<SVG svg={ModulesVerticalSvg}/>);
import ModulesSvg from './unit-editor/modules.svg';
export const Modules = (_p) => (<SVG svg={ModulesSvg}/>);
import OpeningSvg from './unit-editor/opening.svg';
export const Opening = (_p) => (<SVG svg={OpeningSvg}/>);
import PresetsSvg from './unit-editor/presets.svg';
export const Presets = (_p) => (<SVG svg={PresetsSvg}/>);
import SelectSvg from './unit-editor/select.svg';
export const Select = (_p) => (<SVG svg={SelectSvg}/>);
import UnitsSvg from './unit-editor/units.svg';
export const Units = (_p) => (<SVG svg={UnitsSvg}/>);
import WallBoxSvg from './unit-editor/wall-box.svg';
export const WallBox = (_p) => (<SVG svg={WallBoxSvg}/>);
import WallSvg from './unit-editor/wall.svg';
export const Wall = (_p) => (<SVG svg={WallSvg}/>);
import WindowsSvg from './unit-editor/windows.svg';
export const Windows = (_p) => (<SVG svg={WindowsSvg}/>);
import UnlockedSvg from './common/unlocked.svg';
export const Unlocked = (_p) => (<SVG svg={UnlockedSvg}/>);
import OneColumnSvg from './user-reports/1 column.svg';
export const OneColumn = (_p) => (<SVG svg={OneColumnSvg}/>);
import TwoColumnSvg from './user-reports/2 column.svg';
export const TwoColumn = (_p) => (<SVG svg={TwoColumnSvg}/>);
import BarSvg from './user-reports/bar.svg';
export const Bar = (_p) => (<SVG svg={BarSvg}/>);
import BoldSvg from './user-reports/bold.svg';
export const Bold = (_p) => (<SVG svg={BoldSvg}/>);
import BottomUserReportsSvg from './user-reports/bottom.svg';
export const BottomUserReports = (_p) => (<SVG svg={BottomUserReportsSvg}/>);
import ChartsSvg from './user-reports/charts.svg';
export const Charts = (_p) => (<SVG svg={ChartsSvg}/>);
import ClearFormatSvg from './user-reports/clear_format.svg';
export const ClearFormat = (_p) => (<SVG svg={ClearFormatSvg}/>);
import CodeSvg from './user-reports/code.svg';
export const Code = (_p) => (<SVG svg={CodeSvg}/>);
import FloorPlanSvg from './user-reports/floorplan.svg';
export const FloorPlan = (_p) => (<SVG svg={FloorPlanSvg}/>);
import HeadingSvg from './user-reports/heading.svg';
export const Heading = (_p) => (<SVG svg={HeadingSvg}/>);
import ItalicSvg from './user-reports/italic.svg';
export const Italic = (_p) => (<SVG svg={ItalicSvg}/>);
import MapSvg from './user-reports/map.svg';
export const Map = (_p) => (<SVG svg={MapSvg}/>);
import OlSvg from './user-reports/ol.svg';
export const Ol = (_p) => (<SVG svg={OlSvg}/>);
import PieSvg from './user-reports/pie.svg';
export const Pie = (_p) => (<SVG svg={PieSvg}/>);
import SitePlanSvg from './user-reports/site plan.svg';
export const SitePlan = (_p) => (<SVG svg={SitePlanSvg}/>);
import SixDotesSvg from './user-reports/six-dotes.svg';
export const SixDotes = (_p) => (<SVG svg={SixDotesSvg}/>);
import SpecSvg from './user-reports/spec.svg';
export const Spec = (_p) => (<SVG svg={SpecSvg}/>);
import TextToolSvg from './user-reports/text-tool.svg';
export const TextTool = (_p) => (<SVG svg={TextToolSvg}/>);
import TextSvg from './user-reports/text.svg';
export const Text = (_p) => (<SVG svg={TextSvg}/>);
import TextCenterSvg from './user-reports/text_center.svg';
export const TextCenter = (_p) => (<SVG svg={TextCenterSvg}/>);
import TextLeftSvg from './user-reports/text_left.svg';
export const TextLeft = (_p) => (<SVG svg={TextLeftSvg}/>);
import TextRightSvg from './user-reports/text_right.svg';
export const TextRight = (_p) => (<SVG svg={TextRightSvg}/>);
import TopSvg from './user-reports/top.svg';
export const Top = (_p) => (<SVG svg={TopSvg}/>);
import UlSvg from './user-reports/ul.svg';
export const Ul = (_p) => (<SVG svg={UlSvg}/>);
import UsernameSvg from './common/username.svg';
export const Username = (_p) => (<SVG svg={UsernameSvg}/>);
import CompareVersionSvg from './versions/compare.svg';
export const CompareVersion = (_p) => (<SVG svg={CompareVersionSvg}/>);
import CreateVersionSvg from './versions/create_version.svg';
export const CreateVersion = (_p) => (<SVG svg={CreateVersionSvg}/>);
import ReplaceVersionSvg from './versions/replace_version.svg';
export const ReplaceVersion = (_p) => (<SVG svg={ReplaceVersionSvg}/>);
import VersionsSvg from './common/versions.svg';
export const Versions = (_p) => (<SVG svg={VersionsSvg}/>);
import VideoSvg from './common/video.svg';
export const Video = (_p) => (<SVG svg={VideoSvg}/>);
import VideosSvg from './common/videos.svg';
export const Videos = (_p) => (<SVG svg={VideosSvg}/>);
import VisibleSvg from './common/visible.svg';
export const Visible = (_p) => (<SVG svg={VisibleSvg}/>);
import WallsSvg from './common/walls.svg';
export const Walls = (_p) => (<SVG svg={WallsSvg}/>);
import WarningNoCircleSvg from './common/warning-no-circle.svg';
export const WarningNoCircle = (_p) => (<SVG svg={WarningNoCircleSvg}/>);
import WarningSvg from './common/warning.svg';
export const Warning = (_p) => (<SVG svg={WarningSvg}/>);
import WebSiteSvg from './common/web-site.svg';
export const WebSite = (_p) => (<SVG svg={WebSiteSvg}/>);
import WhatsNewSvg from './common/whatsnew.svg';
export const WhatsNew = (_p) => (<SVG svg={WhatsNewSvg}/>);
import MagicWandSvg from './common/magic_wand.svg';
export const MagicWand = (_p) => (<SVG svg={MagicWandSvg}/>);
import PageSvg from './common/page.svg';
export const Page = (_p) => (<SVG svg={PageSvg}/>);
import AssembliesDataBaseSvg from './2d-takeoff/assemblies-data-base.svg';
export const AssembliesDataBase = (_p) => (<SVG svg={AssembliesDataBaseSvg}/>);
import AxisDataBaseSvg from './2d-takeoff/assemblies-database/axis.svg';
export const AxisDataBase = (_p) => (<SVG svg={AxisDataBaseSvg}/>);
import BoxDataBaseSvg from './2d-takeoff/assemblies-database/box.svg';
export const BoxDataBase = (_p) => (<SVG svg={BoxDataBaseSvg}/>);
import BricksDataBaseSvg from './2d-takeoff/assemblies-database/bricks.svg';
export const BricksDataBase = (_p) => (<SVG svg={BricksDataBaseSvg}/>);
import BriefcaseDataBaseSvg from './2d-takeoff/assemblies-database/briefcase.svg';
export const BriefcaseDataBase = (_p) => (<SVG svg={BriefcaseDataBaseSvg}/>);
import BrushDataBaseSvg from './2d-takeoff/assemblies-database/brush.svg';
export const BrushDataBase = (_p) => (<SVG svg={BrushDataBaseSvg}/>);
import BucketDataBaseSvg from './2d-takeoff/assemblies-database/bucket.svg';
export const BucketDataBase = (_p) => (<SVG svg={BucketDataBaseSvg}/>);
import BulbDataBaseSvg from './2d-takeoff/assemblies-database/bulb.svg';
export const BulbDataBase = (_p) => (<SVG svg={BulbDataBaseSvg}/>);
import CementDataBaseSvg from './2d-takeoff/assemblies-database/cement.svg';
export const CementDataBase = (_p) => (<SVG svg={CementDataBaseSvg}/>);
import CircularTubesDataBaseSvg from './2d-takeoff/assemblies-database/circular-tubes.svg';
export const CircularTubesDataBase = (_p) => (<SVG svg={CircularTubesDataBaseSvg}/>);
import ColumnDataBaseSvg from './2d-takeoff/assemblies-database/column.svg';
export const ColumnDataBase = (_p) => (<SVG svg={ColumnDataBaseSvg}/>);
import ConstructionGridDataBaseSvg from './2d-takeoff/assemblies-database/constructiongrid.svg';
export const ConstructionGridDataBase = (_p) => (<SVG svg={ConstructionGridDataBaseSvg}/>);
import CordDataBaseSvg from './2d-takeoff/assemblies-database/cord.svg';
export const CordDataBase = (_p) => (<SVG svg={CordDataBaseSvg}/>);
import CraneDataBaseSvg from './2d-takeoff/assemblies-database/crane.svg';
export const CraneDataBase = (_p) => (<SVG svg={CraneDataBaseSvg}/>);
import CranewaterDataBaseSvg from './2d-takeoff/assemblies-database/cranewater.svg';
export const CranewaterDataBase = (_p) => (<SVG svg={CranewaterDataBaseSvg}/>);
import DimensionDataBaseSvg from './2d-takeoff/assemblies-database/dimension.svg';
export const DimensionDataBase = (_p) => (<SVG svg={DimensionDataBaseSvg}/>);
import DoorDataBaseSvg from './2d-takeoff/assemblies-database/door.svg';
export const DoorDataBase = (_p) => (<SVG svg={DoorDataBaseSvg}/>);
import ElbowDataBaseSvg from './2d-takeoff/assemblies-database/elbow.svg';
export const ElbowDataBase = (_p) => (<SVG svg={ElbowDataBaseSvg}/>);
import ElectricPlugDataBaseSvg from './2d-takeoff/assemblies-database/electric-plug.svg';
export const ElectricPlugDataBase = (_p) => (<SVG svg={ElectricPlugDataBaseSvg}/>);
import ElectricDataBaseSvg from './2d-takeoff/assemblies-database/electric.svg';
export const ElectricDataBase = (_p) => (<SVG svg={ElectricDataBaseSvg}/>);
import FunctionsDataBaseSvg from './2d-takeoff/assemblies-database/functions.svg';
export const FunctionsDataBase = (_p) => (<SVG svg={FunctionsDataBaseSvg}/>);
import GeomteryDataBaseSvg from './2d-takeoff/assemblies-database/geomtery.svg';
export const GeomteryDataBase = (_p) => (<SVG svg={GeomteryDataBaseSvg}/>);
import GlassDataBaseSvg from './2d-takeoff/assemblies-database/glass.svg';
export const GlassDataBase = (_p) => (<SVG svg={GlassDataBaseSvg}/>);
import GroupDataBaseSvg from './2d-takeoff/assemblies-database/group.svg';
export const GroupDataBase = (_p) => (<SVG svg={GroupDataBaseSvg}/>);
import HammerDataBaseSvg from './2d-takeoff/assemblies-database/hammer.svg';
export const HammerDataBase = (_p) => (<SVG svg={HammerDataBaseSvg}/>);
import HelmetDataBaseSvg from './2d-takeoff/assemblies-database/helmet.svg';
export const HelmetDataBase = (_p) => (<SVG svg={HelmetDataBaseSvg}/>);
import HomeDataBaseSvg from './2d-takeoff/assemblies-database/home.svg';
export const HomeDataBase = (_p) => (<SVG svg={HomeDataBaseSvg}/>);
import HookDataBaseSvg from './2d-takeoff/assemblies-database/hook.svg';
export const HookDataBase = (_p) => (<SVG svg={HookDataBaseSvg}/>);
import IBeamDataBaseSvg from './2d-takeoff/assemblies-database/i-beam.svg';
export const IBeamDataBase = (_p) => (<SVG svg={IBeamDataBaseSvg}/>);
import ItemsListSvg from './2d-takeoff/assemblies-database/items-list.svg';
export const ItemsList = (_p) => (<SVG svg={ItemsListSvg}/>);
import JellyDataBaseSvg from './2d-takeoff/assemblies-database/jelly.svg';
export const JellyDataBase = (_p) => (<SVG svg={JellyDataBaseSvg}/>);
import KeyDataBaseSvg from './2d-takeoff/assemblies-database/key.svg';
export const KeyDataBase = (_p) => (<SVG svg={KeyDataBaseSvg}/>);
import LayersDataBaseSvg from './2d-takeoff/assemblies-database/layers.svg';
export const LayersDataBase = (_p) => (<SVG svg={LayersDataBaseSvg}/>);
import Layers2DataBaseSvg from './2d-takeoff/assemblies-database/layers2.svg';
export const Layers2DataBase = (_p) => (<SVG svg={Layers2DataBaseSvg}/>);
import LeafletDataBaseSvg from './2d-takeoff/assemblies-database/leaflet.svg';
export const LeafletDataBase = (_p) => (<SVG svg={LeafletDataBaseSvg}/>);
import LockDataBaseSvg from './2d-takeoff/assemblies-database/lock.svg';
export const LockDataBase = (_p) => (<SVG svg={LockDataBaseSvg}/>);
import MeasurementsListSvg from './2d-takeoff/assemblies-database/measurements-list.svg';
export const MeasurementsList = (_p) => (<SVG svg={MeasurementsListSvg}/>);
import PaintingDataBaseSvg from './2d-takeoff/assemblies-database/painting.svg';
export const PaintingDataBase = (_p) => (<SVG svg={PaintingDataBaseSvg}/>);
import PaperListDataBaseSvg from './2d-takeoff/assemblies-database/paperlist.svg';
export const PaperListDataBase = (_p) => (<SVG svg={PaperListDataBaseSvg}/>);
import ParquetDataBaseSvg from './2d-takeoff/assemblies-database/parquet.svg';
export const ParquetDataBase = (_p) => (<SVG svg={ParquetDataBaseSvg}/>);
import ReinforcmentDataBaseSvg from './2d-takeoff/assemblies-database/reinforcment.svg';
export const ReinforcmentDataBase = (_p) => (<SVG svg={ReinforcmentDataBaseSvg}/>);
import RollerDataBaseSvg from './2d-takeoff/assemblies-database/roller.svg';
export const RollerDataBase = (_p) => (<SVG svg={RollerDataBaseSvg}/>);
import RoofDataBaseSvg from './2d-takeoff/assemblies-database/roof.svg';
export const RoofDataBase = (_p) => (<SVG svg={RoofDataBaseSvg}/>);
import Roof2sidesDataBaseSvg from './2d-takeoff/assemblies-database/roof2sides.svg';
export const Roof2sidesDataBase = (_p) => (<SVG svg={Roof2sidesDataBaseSvg}/>);
import RulerDataBaseSvg from './2d-takeoff/assemblies-database/ruler.svg';
export const RulerDataBase = (_p) => (<SVG svg={RulerDataBaseSvg}/>);
import RulersDataBaseSvg from './2d-takeoff/assemblies-database/rulers.svg';
export const RulersDataBase = (_p) => (<SVG svg={RulersDataBaseSvg}/>);
import SawDataBaseSvg from './2d-takeoff/assemblies-database/saw.svg';
export const SawDataBase = (_p) => (<SVG svg={SawDataBaseSvg}/>);
import ScrewDataBaseSvg from './2d-takeoff/assemblies-database/screw.svg';
export const ScrewDataBase = (_p) => (<SVG svg={ScrewDataBaseSvg}/>);
import ScrewdriverDataBaseSvg from './2d-takeoff/assemblies-database/screwdriver.svg';
export const ScrewdriverDataBase = (_p) => (<SVG svg={ScrewdriverDataBaseSvg}/>);
import ShovelDataBaseSvg from './2d-takeoff/assemblies-database/shovel.svg';
export const ShovelDataBase = (_p) => (<SVG svg={ShovelDataBaseSvg}/>);
import SlabDataBaseSvg from './2d-takeoff/assemblies-database/slab.svg';
export const SlabDataBase = (_p) => (<SVG svg={SlabDataBaseSvg}/>);
import SmileDataBaseSvg from './2d-takeoff/assemblies-database/smile.svg';
export const SmileDataBase = (_p) => (<SVG svg={SmileDataBaseSvg}/>);
import SpatulaDataBaseSvg from './2d-takeoff/assemblies-database/spatula.svg';
export const SpatulaDataBase = (_p) => (<SVG svg={SpatulaDataBaseSvg}/>);
import StairDataBaseSvg from './2d-takeoff/assemblies-database/stair.svg';
export const StairDataBase = (_p) => (<SVG svg={StairDataBaseSvg}/>);
import SteelplateDataBaseSvg from './2d-takeoff/assemblies-database/steelplate.svg';
export const SteelplateDataBase = (_p) => (<SVG svg={SteelplateDataBaseSvg}/>);
import StoneDataBaseSvg from './2d-takeoff/assemblies-database/stone.svg';
export const StoneDataBase = (_p) => (<SVG svg={StoneDataBaseSvg}/>);
import TilesDataBaseSvg from './2d-takeoff/assemblies-database/tiles.svg';
export const TilesDataBase = (_p) => (<SVG svg={TilesDataBaseSvg}/>);
import TubeDataBaseSvg from './2d-takeoff/assemblies-database/tube.svg';
export const TubeDataBase = (_p) => (<SVG svg={TubeDataBaseSvg}/>);
import TubesDataBaseSvg from './2d-takeoff/assemblies-database/tubes.svg';
export const TubesDataBase = (_p) => (<SVG svg={TubesDataBaseSvg}/>);
import ValveDataBaseSvg from './2d-takeoff/assemblies-database/valve.svg';
export const ValveDataBase = (_p) => (<SVG svg={ValveDataBaseSvg}/>);
import VenttubeDataBaseSvg from './2d-takeoff/assemblies-database/venttube.svg';
export const VenttubeDataBase = (_p) => (<SVG svg={VenttubeDataBaseSvg}/>);
import WallDataBaseSvg from './2d-takeoff/assemblies-database/wall.svg';
export const WallDataBase = (_p) => (<SVG svg={WallDataBaseSvg}/>);
import WaterDataBaseSvg from './2d-takeoff/assemblies-database/water.svg';
export const WaterDataBase = (_p) => (<SVG svg={WaterDataBaseSvg}/>);
import WeldingDataBaseSvg from './2d-takeoff/assemblies-database/welding.svg';
export const WeldingDataBase = (_p) => (<SVG svg={WeldingDataBaseSvg}/>);
import WheelbarrowDataBaseSvg from './2d-takeoff/assemblies-database/wheelbarrow.svg';
export const WheelbarrowDataBase = (_p) => (<SVG svg={WheelbarrowDataBaseSvg}/>);
import WindowDataBaseSvg from './2d-takeoff/assemblies-database/window.svg';
export const WindowDataBase = (_p) => (<SVG svg={WindowDataBaseSvg}/>);
import WoodDataBaseSvg from './2d-takeoff/assemblies-database/wood.svg';
export const WoodDataBase = (_p) => (<SVG svg={WoodDataBaseSvg}/>);
import CellRangeFilterSvg from './2d-takeoff/cell-range-filter.svg';
export const CellRangeFilter = (_p) => (<SVG svg={CellRangeFilterSvg}/>);
import ClickOnCheckboxSvg from './2d-takeoff/click-on-checkbox.svg';
export const ClickOnCheckbox = (_p) => (<SVG svg={ClickOnCheckboxSvg}/>);
import DashedSvg from './2d-takeoff/line-dashed.svg';
export const Dashed = (_p) => (<SVG svg={DashedSvg}/>);
import DashedpointSvg from './2d-takeoff/line-dashedpoint.svg';
export const Dashedpoint = (_p) => (<SVG svg={DashedpointSvg}/>);
import ItemsSvg from './2d-takeoff/items.svg';
export const Items = (_p) => (<SVG svg={ItemsSvg}/>);
import Select_2dSvg from './2d-takeoff/select.svg';
export const Select_2d = (_p) => (<SVG svg={Select_2dSvg}/>);
import SingleSelectSvg from './2d-takeoff/single-select.svg';
export const SingleSelect = (_p) => (<SVG svg={SingleSelectSvg}/>);
import TextDataBaseSvg from './2d-takeoff/text-data-base.svg';
export const TextDataBase = (_p) => (<SVG svg={TextDataBaseSvg}/>);
import Rectangle_2Svg from './2d-takeoff/rectangle_2.svg';
export const Rectangle_2 = (_p) => (<SVG svg={Rectangle_2Svg}/>);
import Rectangle_3Svg from './2d-takeoff/rectangle_3.svg';
export const Rectangle_3 = (_p) => (<SVG svg={Rectangle_3Svg}/>);
import LineSvg from './2d-takeoff/line.svg';
export const Line = (_p) => (<SVG svg={LineSvg}/>);
import Polygon_2dSvg from './2d-takeoff/polygon_2d.svg';
export const Polygon_2d = (_p) => (<SVG svg={Polygon_2dSvg}/>);
import PointSvg from './2d-takeoff/point.svg';
export const Point = (_p) => (<SVG svg={PointSvg}/>);
import LayersSvg from './2d-takeoff/layers.svg';
export const Layers = (_p) => (<SVG svg={LayersSvg}/>);
import ParameterSvg from './2d-takeoff/parameter.svg';
export const Parameter = (_p) => (<SVG svg={ParameterSvg}/>);
import ParameterGroupSvg from './2d-takeoff/parameter-group.svg';
export const ParameterGroup = (_p) => (<SVG svg={ParameterGroupSvg}/>);
import ParameterGroupHideSvg from './2d-takeoff/parameter-group-hide.svg';
export const ParameterGroupHide = (_p) => (<SVG svg={ParameterGroupHideSvg}/>);
import PropertiesDataBaseSvg from './2d-takeoff/properties_2.svg';
export const PropertiesDataBase = (_p) => (<SVG svg={PropertiesDataBaseSvg}/>);
import Circle2DSvg from './2d-takeoff/circle.svg';
export const Circle2D = (_p) => (<SVG svg={Circle2DSvg}/>);
import DeleteRow2DSvg from './2d-takeoff/delete-row-2d.svg';
export const DeleteRow2D = (_p) => (<SVG svg={DeleteRow2DSvg}/>);
import InsertColumn2DSvg from './2d-takeoff/insert-column-2d.svg';
export const InsertColumn2D = (_p) => (<SVG svg={InsertColumn2DSvg}/>);
import DeleteColumn2DSvg from './2d-takeoff/delete-column-2d.svg';
export const DeleteColumn2D = (_p) => (<SVG svg={DeleteColumn2DSvg}/>);
import InsertRow2DSvg from './2d-takeoff/insert-row-2d.svg';
export const InsertRow2D = (_p) => (<SVG svg={InsertRow2DSvg}/>);
import Circle2DCenterSvg from './2d-takeoff/circle-center.svg';
export const Circle2DCenter = (_p) => (<SVG svg={Circle2DCenterSvg}/>);
import Circle2D2PointSvg from './2d-takeoff/circle-2-point.svg';
export const Circle2D2Point = (_p) => (<SVG svg={Circle2D2PointSvg}/>);
import FoldersFullSvg from './common/folders_full.svg';
export const FoldersFull = (_p) => (<SVG svg={FoldersFullSvg}/>);
import Hide2DSvg from './2d-takeoff/hide_1.svg';
export const Hide2D = (_p) => (<SVG svg={Hide2DSvg}/>);
import NewYearSvg from './2d-takeoff/happy-new-year.svg';
export const NewYear = (_p) => (<SVG svg={NewYearSvg}/>);
import NumberSvg from './2d-takeoff/number.svg';
export const Number = (_p) => (<SVG svg={NumberSvg}/>);
import NoChargesSvg from './2d-takeoff/no-charges.svg';
export const NoCharges = (_p) => (<SVG svg={NoChargesSvg}/>);
import Show2DSvg from './2d-takeoff/show.svg';
export const Show2D = (_p) => (<SVG svg={Show2DSvg}/>);
import Perimeter2DSvg from './2d-takeoff/perimeter.svg';
export const Perimeter2D = (_p) => (<SVG svg={Perimeter2DSvg}/>);
import Square2DSvg from './2d-takeoff/square.svg';
export const Square2D = (_p) => (<SVG svg={Square2DSvg}/>);
import LineSmallSvg from './2d-takeoff/line_small.svg';
export const LineSmall = (_p) => (<SVG svg={LineSmallSvg}/>);
import DotSmallSvg from './2d-takeoff/dot_small.svg';
export const DotSmall = (_p) => (<SVG svg={DotSmallSvg}/>);
import ExcludeOverlapSvg from './2d-takeoff/Exclude_Overlap.svg';
export const ExcludeOverlap = (_p) => (<SVG svg={ExcludeOverlapSvg}/>);
import IntersectSvg from './2d-takeoff/Intersect.svg';
export const Intersect = (_p) => (<SVG svg={IntersectSvg}/>);
import MenuFileManagerSvg from './2d-takeoff/menu-file-manager.svg';
export const MenuFileManager = (_p) => (<SVG svg={MenuFileManagerSvg}/>);
import SolidSvg from './2d-takeoff/line-solid.svg';
export const Solid = (_p) => (<SVG svg={SolidSvg}/>);
import SubtractSvg from './2d-takeoff/Subtract.svg';
export const Subtract = (_p) => (<SVG svg={SubtractSvg}/>);
import SubtractEmptySvg from './2d-takeoff/subtract-empty.svg';
export const SubtractEmpty = (_p) => (<SVG svg={SubtractEmptySvg}/>);
import UnionSvg from './2d-takeoff/Union.svg';
export const Union = (_p) => (<SVG svg={UnionSvg}/>);
import BackgroundSvg from './common/background.svg';
export const Background = (_p) => (<SVG svg={BackgroundSvg}/>);
import CutSvg from './common/cut.svg';
export const Cut = (_p) => (<SVG svg={CutSvg}/>);
import FormatSvg from './common/format.svg';
export const Format = (_p) => (<SVG svg={FormatSvg}/>);
import PasteSvg from './common/paste.svg';
export const Paste = (_p) => (<SVG svg={PasteSvg}/>);
import ASvg from './common/text.svg';
export const A = (_p) => (<SVG svg={ASvg}/>);
import MergeSvg from './common/merge.svg';
export const Merge = (_p) => (<SVG svg={MergeSvg}/>);
import UnderlineSvg from './common/underline.svg';
export const Underline = (_p) => (<SVG svg={UnderlineSvg}/>);
import StrikeThroughSvg from './common/strikethrough.svg';
export const StrikeThrough = (_p) => (<SVG svg={StrikeThroughSvg}/>);
import VisualSearchSvg from './2d-takeoff/visual_search.svg';
export const VisualSearch = (_p) => (<SVG svg={VisualSearchSvg}/>);
import Modify2DSvg from './2d-takeoff/modify.svg';
export const Modify2D = (_p) => (<SVG svg={Modify2DSvg}/>);
import CopyDuplicateSvg from './2d-takeoff/copy-duplicate.svg';
export const CopyDuplicate = (_p) => (<SVG svg={CopyDuplicateSvg}/>);
import PerimeterBigSvg from './2d-takeoff/perimeter_big.svg';
export const PerimeterBig = (_p) => (<SVG svg={PerimeterBigSvg}/>);
import Edit2DSvg from './2d-takeoff/edit_2d.svg';
export const Edit2D = (_p) => (<SVG svg={Edit2DSvg}/>);
import ExitFullscreenSvg from './2d-takeoff/exit_fullscreen.svg';
export const ExitFullscreen = (_p) => (<SVG svg={ExitFullscreenSvg}/>);
import UnGroup2DSvg from './2d-takeoff/un_group.svg';
export const UnGroup2D = (_p) => (<SVG svg={UnGroup2DSvg}/>);
import MoveToCellSvg from './2d-takeoff/move-to-cell.svg';
export const MoveToCell = (_p) => (<SVG svg={MoveToCellSvg}/>);
import DynamicMoveToCellSvg from './2d-takeoff/dynamic-move-to-cell.svg';
export const DynamicMoveToCell = (_p) => (<SVG svg={DynamicMoveToCellSvg}/>);
import AutoMoveToCellSvg from './2d-takeoff/auto-move-to-cell.svg';
export const AutoMoveToCell = (_p) => (<SVG svg={AutoMoveToCellSvg}/>);
import LinesSvg from './common/lines.svg';
export const Lines = (_p) => (<SVG svg={LinesSvg}/>);
import DotSvg from './common/dot.svg';
export const Dot = (_p) => (<SVG svg={DotSvg}/>);
import ShapesSvg from './common/shapes.svg';
export const Shapes = (_p) => (<SVG svg={ShapesSvg}/>);
import RenameSvg from './common/rename.svg';
export const Rename = (_p) => (<SVG svg={RenameSvg}/>);
import RenameToolSvg from './common/rename-tool.svg';
export const RenameTool = (_p) => (<SVG svg={RenameToolSvg}/>);
import TabBottomSvg from './common/tabbottom.svg';
export const TabBottom = (_p) => (<SVG svg={TabBottomSvg}/>);
import TabLeftSvg from './common/tableft.svg';
export const TabLeft = (_p) => (<SVG svg={TabLeftSvg}/>);
import TabRightSvg from './common/tabright.svg';
export const TabRight = (_p) => (<SVG svg={TabRightSvg}/>);
import SheetSvg from './common/sheet.svg';
export const Sheet = (_p) => (<SVG svg={SheetSvg}/>);
import DoneSmallSvg from './common/done_small.svg';
export const DoneSmall = (_p) => (<SVG svg={DoneSmallSvg}/>);
import HeightRectangleSvg from './2d-takeoff/height-rectangle.svg';
export const HeightRectangle = (_p) => (<SVG svg={HeightRectangleSvg}/>);
import WidthRectangleSvg from './2d-takeoff/width-rectangle.svg';
export const WidthRectangle = (_p) => (<SVG svg={WidthRectangleSvg}/>);
import AddRowsSvg from './2d-takeoff/add-rows.svg';
export const AddRows = (_p) => (<SVG svg={AddRowsSvg}/>);
import AddColumnsSvg from './2d-takeoff/add-columns.svg';
export const AddColumns = (_p) => (<SVG svg={AddColumnsSvg}/>);
import Area2DSvg from './2d-takeoff/area-2d.svg';
export const Area2D = (_p) => (<SVG svg={Area2DSvg}/>);
import AutoMeasureSvg from './2d-takeoff/auto-measure.svg';
export const AutoMeasure = (_p) => (<SVG svg={AutoMeasureSvg}/>);
import Chat2DSvg from './2d-takeoff/chat.svg';
export const Chat2D = (_p) => (<SVG svg={Chat2DSvg}/>);
import Comments2DSvg from './2d-takeoff/comments.svg';
export const Comments2D = (_p) => (<SVG svg={Comments2DSvg}/>);
import Bellka2DSvg from './2d-takeoff/bellka.svg';
export const Bellka2D = (_p) => (<SVG svg={Bellka2DSvg}/>);
import ReOpen2DSvg from './2d-takeoff/re-open.svg';
export const ReOpen2D = (_p) => (<SVG svg={ReOpen2DSvg}/>);
import HelpCenter2DSvg from './2d-takeoff/help_center.svg';
export const HelpCenter2D = (_p) => (<SVG svg={HelpCenter2DSvg}/>);
import KreoLogo2DSvg from './2d-takeoff/kreo-logo-2d.svg';
export const KreoLogo2D = (_p) => (<SVG svg={KreoLogo2DSvg}/>);
import KreoSmallLogo2DSvg from './2d-takeoff/kreo-small-logo-2d.svg';
export const KreoSmallLogo2D = (_p) => (<SVG svg={KreoSmallLogo2DSvg}/>);
import Shortcut2DSvg from './2d-takeoff/shortcut.svg';
export const Shortcut2D = (_p) => (<SVG svg={Shortcut2DSvg}/>);
import SmallQuestion2DSvg from './2d-takeoff/small_question.svg';
export const SmallQuestion2D = (_p) => (<SVG svg={SmallQuestion2DSvg}/>);
import Videos2DSvg from './2d-takeoff/videos.svg';
export const Videos2D = (_p) => (<SVG svg={Videos2DSvg}/>);
import WhatsNews2DSvg from './2d-takeoff/whats_news.svg';
export const WhatsNews2D = (_p) => (<SVG svg={WhatsNews2DSvg}/>);
import Tracelinks2DSvg from './2d-takeoff/tracelinks.svg';
export const Tracelinks2D = (_p) => (<SVG svg={Tracelinks2DSvg}/>);
import TwoViewsStackedSvg from './2d-takeoff/views-split/2-views-stacked.svg';
export const TwoViewsStacked = (_p) => (<SVG svg={TwoViewsStackedSvg}/>);
import TwoViewsSideBySideSvg from './2d-takeoff/views-split/2-views-side-by-side.svg';
export const TwoViewsSideBySide = (_p) => (<SVG svg={TwoViewsSideBySideSvg}/>);
import ThreeViewsTopSplitSvg from './2d-takeoff/views-split/3-views-top-split.svg';
export const ThreeViewsTopSplit = (_p) => (<SVG svg={ThreeViewsTopSplitSvg}/>);
import ThreeViewsBottomSplitSvg from './2d-takeoff/views-split/3-views-bottom-split.svg';
export const ThreeViewsBottomSplit = (_p) => (<SVG svg={ThreeViewsBottomSplitSvg}/>);
import ThreeViewsLeftSplitSvg from './2d-takeoff/views-split/3-views-left-split.svg';
export const ThreeViewsLeftSplit = (_p) => (<SVG svg={ThreeViewsLeftSplitSvg}/>);
import ThreeViewsRightSplitSvg from './2d-takeoff/views-split/3-views-right-split.svg';
export const ThreeViewsRightSplit = (_p) => (<SVG svg={ThreeViewsRightSplitSvg}/>);
import FourViewsSvg from './2d-takeoff/views-split/4-views.svg';
export const FourViews = (_p) => (<SVG svg={FourViewsSvg}/>);
import FourViewsBottomSplitSvg from './2d-takeoff/views-split/4-views-bottom-split.svg';
export const FourViewsBottomSplit = (_p) => (<SVG svg={FourViewsBottomSplitSvg}/>);
import FourViewsTopSplitSvg from './2d-takeoff/views-split/4-views-top-split.svg';
export const FourViewsTopSplit = (_p) => (<SVG svg={FourViewsTopSplitSvg}/>);
import FourViewsLeftSplitSvg from './2d-takeoff/views-split/4-views-left-split.svg';
export const FourViewsLeftSplit = (_p) => (<SVG svg={FourViewsLeftSplitSvg}/>);
import FourViewsRightSplitSvg from './2d-takeoff/views-split/4-views-right-split.svg';
export const FourViewsRightSplit = (_p) => (<SVG svg={FourViewsRightSplitSvg}/>);
import FourViewsStackedSvg from './2d-takeoff/views-split/4-views-stacked.svg';
export const FourViewsStacked = (_p) => (<SVG svg={FourViewsStackedSvg}/>);
import FourViewsSideBySideSvg from './2d-takeoff/views-split/4-views-side-by-side.svg';
export const FourViewsSideBySide = (_p) => (<SVG svg={FourViewsSideBySideSvg}/>);
import SingleViewSvg from './2d-takeoff/views-split/single-view.svg';
export const SingleView = (_p) => (<SVG svg={SingleViewSvg}/>);
import AddNewGroupSvg from './2d-takeoff/add-new-group.svg';
export const AddNewGroup = (_p) => (<SVG svg={AddNewGroupSvg}/>);
import MoveToGroupSvg from './2d-takeoff/move-to-group.svg';
export const MoveToGroup = (_p) => (<SVG svg={MoveToGroupSvg}/>);
import Isolate2DSvg from './2d-takeoff/isolate.svg';
export const Isolate2D = (_p) => (<SVG svg={Isolate2DSvg}/>);
import FeatureRequestSvg from './2d-takeoff/feature-request.svg';
export const FeatureRequest = (_p) => (<SVG svg={FeatureRequestSvg}/>);
import Name2DSvg from './2d-takeoff/name.svg';
export const Name2D = (_p) => (<SVG svg={Name2DSvg}/>);
import Table2DSvg from './2d-takeoff/table.svg';
export const Table2D = (_p) => (<SVG svg={Table2DSvg}/>);
import PageName2DSvg from './2d-takeoff/page-name.svg';
export const PageName2D = (_p) => (<SVG svg={PageName2DSvg}/>);
import ProtectedByStripeSvg from './2d-takeoff/protected-by-stripe.svg';
export const ProtectedByStripe = (_p) => (<SVG svg={ProtectedByStripeSvg}/>);
import FindTextSvg from './2d-takeoff/find-text.svg';
export const FindText = (_p) => (<SVG svg={FindTextSvg}/>);
import FindGeometrySvg from './2d-takeoff/find-geometry.svg';
export const FindGeometry = (_p) => (<SVG svg={FindGeometrySvg}/>);
import Filters2DSvg from './2d-takeoff/filters-2d.svg';
export const Filters2D = (_p) => (<SVG svg={Filters2DSvg}/>);
import InsertRowSvg from './2d-takeoff/insert-row.svg';
export const InsertRow = (_p) => (<SVG svg={InsertRowSvg}/>);
import InsertColumnSvg from './2d-takeoff/insert-column.svg';
export const InsertColumn = (_p) => (<SVG svg={InsertColumnSvg}/>);
import DeleteColumnSvg from './2d-takeoff/delete-column.svg';
export const DeleteColumn = (_p) => (<SVG svg={DeleteColumnSvg}/>);
import DeleteRowSvg from './2d-takeoff/delete-row.svg';
export const DeleteRow = (_p) => (<SVG svg={DeleteRowSvg}/>);
import DemoProjectsSvg from './2d-takeoff/demo-project.svg';
export const DemoProjects = (_p) => (<SVG svg={DemoProjectsSvg}/>);
import RotateLeftSvg from './2d-takeoff/rotate-left.svg';
export const RotateLeft = (_p) => (<SVG svg={RotateLeftSvg}/>);
import RotateRightSvg from './2d-takeoff/rotate-right.svg';
export const RotateRight = (_p) => (<SVG svg={RotateRightSvg}/>);
import OffsetSvg from './2d-takeoff/offset.svg';
export const Offset = (_p) => (<SVG svg={OffsetSvg}/>);
import OpenNewTabSvg from './2d-takeoff/open-new-tab.svg';
export const OpenNewTab = (_p) => (<SVG svg={OpenNewTabSvg}/>);
import StrokeOffsetSvg from './2d-takeoff/offset-stroke.svg';
export const StrokeOffset = (_p) => (<SVG svg={StrokeOffsetSvg}/>);
import SubscribeSvg from './reusable/subscribe.svg';
export const Subscribe = (_p) => (<SVG svg={SubscribeSvg}/>);
import Settings2DSvg from './2d-takeoff/settings-2d.svg';
export const Settings2D = (_p) => (<SVG svg={Settings2DSvg}/>);
import ShareProjectSvg from './2d-takeoff/share-project.svg';
export const ShareProject = (_p) => (<SVG svg={ShareProjectSvg}/>);
import ZoomInSvg from './2d-takeoff/zoom_in.svg';
export const ZoomIn = (_p) => (<SVG svg={ZoomInSvg}/>);
import ZoomOutSvg from './2d-takeoff/zoom_out.svg';
export const ZoomOut = (_p) => (<SVG svg={ZoomOutSvg}/>);
import Home2DSvg from './2d-takeoff/home.svg';
export const Home2D = (_p) => (<SVG svg={Home2DSvg}/>);
import Duplicate2DSvg from './2d-takeoff/duplicate.svg';
export const Duplicate2D = (_p) => (<SVG svg={Duplicate2DSvg}/>);
import DeleteFolderSvg from './2d-takeoff/delete-folder.svg';
export const DeleteFolder = (_p) => (<SVG svg={DeleteFolderSvg}/>);
import InvertSvg from './2d-takeoff/invert.svg';
export const Invert = (_p) => (<SVG svg={InvertSvg}/>);
import TabOtherPageSvg from './2d-takeoff/tab-other-page.svg';
export const TabOtherPage = (_p) => (<SVG svg={TabOtherPageSvg}/>);
import AlignBottomSvg from './2d-takeoff/align-bottom.svg';
export const AlignBottom = (_p) => (<SVG svg={AlignBottomSvg}/>);
import AlignLeftSvg from './2d-takeoff/align-left.svg';
export const AlignLeft = (_p) => (<SVG svg={AlignLeftSvg}/>);
import AlignRightSvg from './2d-takeoff/align-right.svg';
export const AlignRight = (_p) => (<SVG svg={AlignRightSvg}/>);
import AlignTopSvg from './2d-takeoff/align-top.svg';
export const AlignTop = (_p) => (<SVG svg={AlignTopSvg}/>);
import LibrarySvg from './2d-takeoff/Library.svg';
export const Library = (_p) => (<SVG svg={LibrarySvg}/>);
import Ruler2DSvg from './2d-takeoff/Ruler.svg';
export const Ruler2D = (_p) => (<SVG svg={Ruler2DSvg}/>);
import StickyNoteSvg from './2d-takeoff/StickyNote.svg';
export const StickyNote = (_p) => (<SVG svg={StickyNoteSvg}/>);
import Question2DSvg from './2d-takeoff/circle-question.svg';
export const Question2D = (_p) => (<SVG svg={Question2DSvg}/>);
import PasteWithPointSvg from './2d-takeoff/paste-with-point.svg';
export const PasteWithPoint = (_p) => (<SVG svg={PasteWithPointSvg}/>);
import Team2DSvg from './2d-takeoff/team.svg';
export const Team2D = (_p) => (<SVG svg={Team2DSvg}/>);
import LineIntersectionSvg from './2d-takeoff/line_intersection.svg';
export const LineIntersection = (_p) => (<SVG svg={LineIntersectionSvg}/>);
import LineMidPointSvg from './2d-takeoff/line_midpoint.svg';
export const LineMidPoint = (_p) => (<SVG svg={LineMidPointSvg}/>);
import PathEndPointSvg from './2d-takeoff/path_endpoint.svg';
export const PathEndPoint = (_p) => (<SVG svg={PathEndPointSvg}/>);
import PointOnLineSvg from './2d-takeoff/point_on_line.svg';
export const PointOnLine = (_p) => (<SVG svg={PointOnLineSvg}/>);
import FlipHorizontallySvg from './2d-takeoff/flip_horizontally.svg';
export const FlipHorizontally = (_p) => (<SVG svg={FlipHorizontallySvg}/>);
import FlipVerticallySvg from './2d-takeoff/flip_vertically.svg';
export const FlipVertically = (_p) => (<SVG svg={FlipVerticallySvg}/>);
import CountJoinSvg from './2d-takeoff/join.svg';
export const CountJoin = (_p) => (<SVG svg={CountJoinSvg}/>);
import CountSplitSvg from './2d-takeoff/split.svg';
export const CountSplit = (_p) => (<SVG svg={CountSplitSvg}/>);
import FolderToCell2DSvg from './2d-takeoff/folder-to-cell.svg';
export const FolderToCell2D = (_p) => (<SVG svg={FolderToCell2DSvg}/>);
import LegendSvg from './2d-takeoff/legend.svg';
export const Legend = (_p) => (<SVG svg={LegendSvg}/>);
import KnifeSvg from './2d-takeoff/knife.svg';
export const Knife = (_p) => (<SVG svg={KnifeSvg}/>);
import Sort2DSvg from './2d-takeoff/sort_2d.svg';
export const Sort2D = (_p) => (<SVG svg={Sort2DSvg}/>);
import GroupSvg from './2d-takeoff/group.svg';
export const Group = (_p) => (<SVG svg={GroupSvg}/>);
import DynamicGuidelineSvg from './2d-takeoff/dynamic-guideline.svg';
export const DynamicGuideline = (_p) => (<SVG svg={DynamicGuidelineSvg}/>);
import MarqueeZoomSvg from './2d-takeoff/marquee-zoom.svg';
export const MarqueeZoom = (_p) => (<SVG svg={MarqueeZoomSvg}/>);
import CircleArrowSvg from './2d-takeoff/circle-arrow.svg';
export const CircleArrow = (_p) => (<SVG svg={CircleArrowSvg}/>);
import CompareDrawingsSvg from './2d-takeoff/compare-drawings.svg';
export const CompareDrawings = (_p) => (<SVG svg={CompareDrawingsSvg}/>);
import AiSuggestSvg from './2d-takeoff/ai-suggest.svg';
export const AiSuggest = (_p) => (<SVG svg={AiSuggestSvg}/>);
import OptimizeSvg from './2d-takeoff/optimize.svg';
export const Optimize = (_p) => (<SVG svg={OptimizeSvg}/>);
import ArrowBottomCircleSvg from './2d-takeoff/arrow-bottom-circle.svg';
export const ArrowBottomCircle = (_p) => (<SVG svg={ArrowBottomCircleSvg}/>);
import PinFolderSvg from './2d-takeoff/pin-folder.svg';
export const PinFolder = (_p) => (<SVG svg={PinFolderSvg}/>);
import ShapeCircleSvg from './2d-takeoff/shapes/circle.svg';
export const ShapeCircle = (_p) => (<SVG svg={ShapeCircleSvg}/>);
import ShapeHexagonSvg from './2d-takeoff/shapes/hexagon.svg';
export const ShapeHexagon = (_p) => (<SVG svg={ShapeHexagonSvg}/>);
import ShapeOctagonSvg from './2d-takeoff/shapes/octagon.svg';
export const ShapeOctagon = (_p) => (<SVG svg={ShapeOctagonSvg}/>);
import ShapePentagonSvg from './2d-takeoff/shapes/pentagon.svg';
export const ShapePentagon = (_p) => (<SVG svg={ShapePentagonSvg}/>);
import ShapeRombSvg from './2d-takeoff/shapes/romb.svg';
export const ShapeRomb = (_p) => (<SVG svg={ShapeRombSvg}/>);
import ShapeRoundedSquareSvg from './2d-takeoff/shapes/rounded-square.svg';
export const ShapeRoundedSquare = (_p) => (<SVG svg={ShapeRoundedSquareSvg}/>);
import ShapeSquareSvg from './2d-takeoff/shapes/square.svg';
export const ShapeSquare = (_p) => (<SVG svg={ShapeSquareSvg}/>);
import ShapeStarSvg from './2d-takeoff/shapes/star.svg';
export const ShapeStar= ShapeStarSvg;
import ShapeTriangleSvg from './2d-takeoff/shapes/triangle.svg';
export const ShapeTriangle = (_p) => (<SVG svg={ShapeTriangleSvg}/>);
import PointsCountSvg from './2d-takeoff/points-count.svg';
export const PointsCount = (_p) => (<SVG svg={PointsCountSvg}/>);
import SegmentsCountSvg from './2d-takeoff/segments-count.svg';
export const SegmentsCount = (_p) => (<SVG svg={SegmentsCountSvg}/>);
import PauseSubscriptionSvg from './2d-takeoff/pause-subscription.svg';
export const PauseSubscription = (_p) => (<SVG svg={PauseSubscriptionSvg}/>);
import MultivaluesSvg from './2d-takeoff/multivalues.svg';
export const Multivalues = (_p) => (<SVG svg={MultivaluesSvg}/>);
import CopySmallSvg from './2d-takeoff/copy-small.svg';
export const CopySmall = (_p) => (<SVG svg={CopySmallSvg}/>);
import DislikeSvg from './2d-takeoff/dislike.svg';
export const Dislike = (_p) => (<SVG svg={DislikeSvg}/>);
import LikeSmallSvg from './2d-takeoff/like-small.svg';
export const LikeSmall = (_p) => (<SVG svg={LikeSmallSvg}/>);
import PauseStopSvg from './2d-takeoff/pause-stop.svg';
export const PauseStop = (_p) => (<SVG svg={PauseStopSvg}/>);
import ResetAiSvg from './2d-takeoff/reset-ai.svg';
export const ResetAi = (_p) => (<SVG svg={ResetAiSvg}/>);
import SendAiSvg from './2d-takeoff/send-ai.svg';
export const SendAi = (_p) => (<SVG svg={SendAiSvg}/>);
import CaddySvg from './2d-takeoff/Caddy.svg';
export const Caddy = (_p) => (<SVG svg={CaddySvg}/>);
import AskAiSvg from './2d-takeoff/ask-ai.svg';
export const AskAi = (_p) => (<SVG svg={AskAiSvg}/>);
import Group_2Svg from './2d-takeoff/group_2.svg';
export const Group_2 = (_p) => (<SVG svg={Group_2Svg}/>);
import CollapseFoldersSvg from './2d-takeoff/collapse-folders.svg';
export const CollapseFolders = (_p) => (<SVG svg={CollapseFoldersSvg}/>);
import NewGroup2dSvg from './2d-takeoff/new-group-2d.svg';
export const NewGroup2d = (_p) => (<SVG svg={NewGroup2dSvg}/>);
import ExpandFoldersSvg from './2d-takeoff/expand-folders.svg';
export const ExpandFolders = (_p) => (<SVG svg={ExpandFoldersSvg}/>);
import Burger_1SmallSvg from './2d-takeoff/burger_1-small.svg';
export const Burger_1Small = (_p) => (<SVG svg={Burger_1SmallSvg}/>);
import BreakdownSvg from './2d-takeoff/breakdown.svg';
export const Breakdown = (_p) => (<SVG svg={BreakdownSvg}/>);
import LinkOnGroupSvg from './2d-takeoff/link-on-group.svg';
export const LinkOnGroup = (_p) => (<SVG svg={LinkOnGroupSvg}/>);
import MoveToGroup_1Svg from './2d-takeoff/move-to-group_1.svg';
export const MoveToGroup_1 = (_p) => (<SVG svg={MoveToGroup_1Svg}/>);
import DeleteEmptyGroupsSvg from './2d-takeoff/delete-empty-groups.svg';
export const DeleteEmptyGroups = (_p) => (<SVG svg={DeleteEmptyGroupsSvg}/>);
import SmallAllSvg from './2d-takeoff/small-all.svg';
export const SmallAll = (_p) => (<SVG svg={SmallAllSvg}/>);
import SmallPinSvg from './2d-takeoff/small-pin.svg';
export const SmallPin = (_p) => (<SVG svg={SmallPinSvg}/>);
import SelectArrowSvg from './2d-takeoff/select-arrow.svg';
export const SelectArrow = (_p) => (<SVG svg={SelectArrowSvg}/>);
import Snapping2DSvg from './2d-takeoff/snapping_2d.svg';
export const Snapping2D = (_p) => (<SVG svg={Snapping2DSvg}/>);
import OrthogonalMode2DSvg from './2d-takeoff/orthogonal-mode-2d.svg';
export const OrthogonalMode2D = (_p) => (<SVG svg={OrthogonalMode2DSvg}/>);
import DuplicateGroupsSvg from './2d-takeoff/duplicate-groups.svg';
export const DuplicateGroups = (_p) => (<SVG svg={DuplicateGroupsSvg}/>);
import DoneIcon2dSvg from './2d-takeoff/done-icon-2d.svg';
export const DoneIcon2d = (_p) => (<SVG svg={DoneIcon2dSvg}/>);
import HelpCenterProject2DSvg from './2d-takeoff/help-center-project-2d.svg';
export const HelpCenterProject2D = (_p) => (<SVG svg={HelpCenterProject2DSvg}/>);
import ShareButtonSvg from './2d-takeoff/share-button.svg';
export const ShareButton = (_p) => (<SVG svg={ShareButtonSvg}/>);
import ReferallProgramSvg from './2d-takeoff/referall-program.svg';
export const ReferallProgram = (_p) => (<SVG svg={ReferallProgramSvg}/>);
import Questions2DSvg from './2d-takeoff/questions-2d.svg';
export const Questions2D = (_p) => (<SVG svg={Questions2DSvg}/>);
import CutPathSVG from './2d-takeoff/cut-path.svg';
export const CutPath = (_p) => (<SVG svg={CutPathSVG}/>);
import JoinPathSVG from './2d-takeoff/join-path.svg';
export const JoinPath = (_p) => (<SVG svg={JoinPathSVG}/>);
import Stars2DSVG from './2d-takeoff/stars-2d.svg';
export const Stars2D = (_p) => (<SVG svg={Stars2DSVG}/>);
import EncloseSvg from './2d-takeoff/Enclose.svg';
export const Enclose = (_p) => (<SVG svg={EncloseSvg}/>);
import BucketSvg from './2d-takeoff/Bucket.svg';
export const Bucket = (_p) => (<SVG svg={BucketSvg}/>);
import WandSvg from './2d-takeoff/Wand.svg';
export const Wand = (_p) => (<SVG svg={WandSvg}/>);
import DropperSvg from './2d-takeoff/Dropper.svg';
export const Dropper = (_p) => (<SVG svg={DropperSvg}/>);
import Finder from './2d-takeoff/Finder.svg';
export const Finder2D = Finder;
import SearchZone2dSvg from './2d-takeoff/search-zone.svg';
export const SearchZone2D = (_p) => (<SVG svg={SearchZone2dSvg}/>);
import Similarity2dSvg from './2d-takeoff/Similarity.svg';
export const Similarity2D = (_p) => (<SVG svg={Similarity2dSvg}/>);
import EraserSvg from './2d-takeoff/Eraser.svg';
export const Eraser = (_p) => (<SVG svg={EraserSvg}/>);
import RenameSmallSvg from './2d-takeoff/rename-small.svg';
export const RenameSmall = (_p) => (<SVG svg={RenameSmallSvg}/>);
import PerimeterSmalllSvg from './2d-takeoff/perimeter-small_1.svg';
export const PerimeterSmall = (_p) => (<SVG svg={PerimeterSmalllSvg}/>);
import AreaSmallSvg from './2d-takeoff/area-small.svg';
export const AreaSmall = (_p) => (<SVG svg={AreaSmallSvg}/>);
import SortingSvg from './2d-takeoff/sorting.svg';
export const Sorting = (_p) => (<SVG svg={SortingSvg}/>);
import RenameToolSmallSvg from './2d-takeoff/rename-tool-small.svg';
export const RenameToolSmall = (_p) => (<SVG svg={RenameToolSmallSvg}/>);
import ScaleSmallSvg from './2d-takeoff/scale-small.svg';
export const ScaleSmall = (_p) => (<SVG svg={ScaleSmallSvg}/>);
import AutoMeasureSmallSvg from './2d-takeoff/auto-measure-2.0.svg';
export const AutoMeasureSmall = (_p) => (<SVG svg={AutoMeasureSmallSvg}/>);
import TextSearchSmallSvg from './2d-takeoff/text-search-small.svg';
export const TextSearchSmall = (_p) => (<SVG svg={TextSearchSmallSvg}/>);
import CompareSmallSvg from './2d-takeoff/compare-small.svg';
export const CompareSmall = (_p) => (<SVG svg={CompareSmallSvg}/>);
import ExportSmallSvg from './2d-takeoff/export-small.svg';
export const ExportSmall = (_p) => (<SVG svg={ExportSmallSvg}/>);
import DrawingSmallSvg from './2d-takeoff/drawing-small.svg';
export const DrawingSmall = (_p) => (<SVG svg={DrawingSmallSvg}/>);
import RotateSmallLeftSvg from './2d-takeoff/rotate-small-left.svg';
export const RotateSmallLeft = (_p) => (<SVG svg={RotateSmallLeftSvg}/>);
import RotateSmallRightSvg from './2d-takeoff/rotate-small-right.svg';
export const RotateSmallRight = (_p) => (<SVG svg={RotateSmallRightSvg}/>);
import AiBadgeSvg from './2d-takeoff/ai-badge.svg';
export const AiBadge = (_p) => (<SVG svg={AiBadgeSvg}/>);
import UnitSystemSvg from './2d-takeoff/unit-system.svg';
export const UnitSystem = (_p) => (<SVG svg={UnitSystemSvg}/>);
import DatabaseSmallSvg from './2d-takeoff/Database-small.svg';
export const DatabaseSmall = (_p) => (<SVG svg={DatabaseSmallSvg}/>);
import VerticalAreaSvg from './2d-takeoff/vertical-area.svg';
export const VerticalArea = (_p) => (<SVG svg={VerticalAreaSvg}/>);
import VolumeSvg from './2d-takeoff/volume.svg';
export const Volume = (_p) => (<SVG svg={VolumeSvg}/>);
import ThreeDViewSvg from './2d-takeoff/3d-view.svg';
export const ThreeDView = (_p) => (<SVG svg={ThreeDViewSvg}/>);
import TwoDViewSvg from './2d-takeoff/2d-view.svg';
export const TwoDView = (_p) => (<SVG svg={TwoDViewSvg}/>);
import CellBackgroundColorSvg from './2d-takeoff/cell-background-color.svg';
export const CellBackgroundColor = (_p) => (<SVG svg={CellBackgroundColorSvg}/>);
import TextAlignRigthSvg from './2d-takeoff/text-align-rigth.svg';
export const TextAlignRigth = (_p) => (<SVG svg={TextAlignRigthSvg}/>);
import TextAlignLeftSvg from './2d-takeoff/text-align-left.svg';
export const TextAlignLeft = (_p) => (<SVG svg={TextAlignLeftSvg}/>);
import TextStrikethroughSvg from './2d-takeoff/text-strikethrough.svg';
export const TextStrikethrough = (_p) => (<SVG svg={TextStrikethroughSvg}/>);
import FunctionsSvg from './2d-takeoff/functions.svg';
export const Functions = (_p) => (<SVG svg={FunctionsSvg}/>);
import TextAlignCenterSvg from './2d-takeoff/text-align-center.svg';
export const TextAlignCenter = (_p) => (<SVG svg={TextAlignCenterSvg}/>);
import TextUnderlineSvg from './2d-takeoff/text-underline.svg';
export const TextUnderline = (_p) => (<SVG svg={TextUnderlineSvg}/>);
import FontColorSvg from './2d-takeoff/font-color.svg';
export const FontColor = (_p) => (<SVG svg={FontColorSvg}/>);
import TextBoldSvg from './2d-takeoff/text-bold.svg';
export const TextBold = (_p) => (<SVG svg={TextBoldSvg}/>);
import TextItalicSvg from './2d-takeoff/text-italic.svg';
export const TextItalic = (_p) => (<SVG svg={TextItalicSvg}/>);
import ClearFormat1Svg from './2d-takeoff/clear-format-1.svg';
export const ClearFormat1 = (_p) => (<SVG svg={ClearFormat1Svg}/>);
import TwoDScreenshotSVG from './2d-takeoff/2d-screen-shot.svg';
export const TwoDScreenshot = (_p) => (<SVG svg={TwoDScreenshotSVG}/>);
import AreaSmallIconSVG from './2d-takeoff/area-small-icon.svg';
export const AreaSmallIcon = (_p) => (<SVG svg={AreaSmallIconSVG}/>);
import CountSmallIconSVG from './2d-takeoff/count-small-icon.svg';
export const CountSmallIcon = (_p) => (<SVG svg={CountSmallIconSVG}/>);
import LinearSmallIconSVG from './2d-takeoff/linear-small-icon.svg';
export const LinearSmallIcon = (_p) => (<SVG svg={LinearSmallIconSVG}/>);
import PerimeterSmallIconSVG from './2d-takeoff/perimeter-small-icon.svg';
export const PerimeterSmallIcon = (_p) => (<SVG svg={PerimeterSmallIconSVG}/>);
import ScreenshotTwoDSVG from './2d-takeoff/screenshot-2d.svg';
export const ScreenshotTwoD = (_p) => (<SVG svg={ScreenshotTwoDSVG}/>);
import MinimapSVG from './2d-takeoff/minimap.svg';
export const Minimap = (_p) => (<SVG svg={MinimapSVG}/>);
import UpgradeProSVG from './2d-takeoff/upgrade-pro.svg';
export const UpgradePro = (_p) => (<SVG svg={UpgradeProSVG}/>);
import CancelSubscriptionSVG from './2d-takeoff/cancel-subscription.svg';
export const CancelSubscription = (_p) => (<SVG svg={CancelSubscriptionSVG}/>);
import Close2dSVG from './2d-takeoff/close-2d.svg';
export const Close2d = (_p) => (<SVG svg={Close2dSVG}/>);
import MagicSearchSvg from './2d-takeoff/magic-search.svg';
export const MagicSearch = (_p) => (<SVG svg={MagicSearchSvg}/>);
import ProjectsNavigationSvg from './2d-takeoff/projects-navigation.svg';
export const ProjectsNavigation = (_p) => (<SVG svg={ProjectsNavigationSvg}/>);
import DemoProjectNavigationSvg from './2d-takeoff/demo-project-navigation.svg';
export const DemoProjectNavigation = (_p) => (<SVG svg={DemoProjectNavigationSvg}/>);

import AddPaymentSvg from './payment/add-payment.svg';
export const AddPayment = (_p) => (<SVG svg={AddPaymentSvg}/>);
import BillingHistorySVG from './payment/billing-history.svg';
export const BillingHistory = (_p) => (<SVG svg={BillingHistorySVG}/>);
import PaymentMethodSVG from './payment/payment-method.svg';
export const PaymentMethod = (_p) => (<SVG svg={PaymentMethodSVG}/>);
import EndPointSvg from './skema/settings/endPoint.svg';
export const EndPoint = (_p) => (<SVG svg={EndPointSvg}/>);
import ExtensionSvg from './skema/settings/extension.svg';
export const Extension = (_p) => (<SVG svg={ExtensionSvg}/>);
import IntersectionSvg from './skema/settings/intersection.svg';
export const Intersection = (_p) => (<SVG svg={IntersectionSvg}/>);
import OrthoSvg from './skema/settings/ortho.svg';
export const Ortho = (_p) => (<SVG svg={OrthoSvg}/>);
import ParalellSvg from './skema/settings/paralell.svg';
export const Paralell = (_p) => (<SVG svg={ParalellSvg}/>);
import RotationSvg from './skema/settings/Rotation.svg';
export const Rotation = (_p) => (<SVG svg={RotationSvg}/>);
import AddlineSvg from './skema/addline.svg';
export const Addline = (_p) => (<SVG svg={AddlineSvg}/>);
import EditSmallSvg from './skema/edit_small.svg';
export const EditSmall = (_p) => (<SVG svg={EditSmallSvg}/>);
import MassingSvg from './skema/massing.svg';
export const Massing = (_p) => (<SVG svg={MassingSvg}/>);
import MoveToSvg from './skema/MoveTo.svg';
export const MoveTo = (_p) => (<SVG svg={MoveToSvg}/>);
import ArrowRotationSvg from './skema/rotationSvg.svg';
export const ArrowRotation = (_p) => (<SVG svg={ArrowRotationSvg}/>);
import SiteAreaSvg from './skema/site_area.svg';
export const SiteArea = (_p) => (<SVG svg={SiteAreaSvg}/>);
import StreetSvg from './skema/street.svg';
export const Street = (_p) => (<SVG svg={StreetSvg}/>);
import SpaceDivisionSvg from './skema/space-division.svg';
export const SpaceDivision = (_p) => (<SVG svg={SpaceDivisionSvg}/>);
import SquareSmallSvg from './skema/square_small.svg';
export const SquareSmall = (_p) => (<SVG svg={SquareSmallSvg}/>);
import HeightSmallSvg from './skema/map/height_small.svg';
export const HeightSmall = (_p) => (<SVG svg={HeightSmallSvg}/>);
import WidthSmallSvg from './skema/map/width_small.svg';
export const WidthSmall = (_p) => (<SVG svg={WidthSmallSvg}/>);
import TemplatesParametersSvg from './skema/templates_parameters.svg';
export const TemplatesParameters = (_p) => (<SVG svg={TemplatesParametersSvg}/>);
import TopologySvg from './skema/Topology.svg';
export const Topology = (_p) => (<SVG svg={TopologySvg}/>);
import LiftSvg from './skema/unit-editor/lift.svg';
export const Lift = (_p) => (<SVG svg={LiftSvg}/>);
import DoubleHingedDoorSvg from './skema/unit-editor/doors/double_hinged.svg';
export const DoubleHingedDoor = (_p) => (<SVG svg={DoubleHingedDoorSvg}/>);
import DoubleSlidingDoorSvg from './skema/unit-editor/doors/double_sliding.svg';
export const DoubleSlidingDoor = (_p) => (<SVG svg={DoubleSlidingDoorSvg}/>);
import SingleHingedDoorSvg from './skema/unit-editor/doors/single_hinged.svg';
export const SingleHingedDoor = (_p) => (<SVG svg={SingleHingedDoorSvg}/>);
import SinglesSlidingDoorSvg from './skema/unit-editor/doors/single_sliding.svg';
export const SinglesSlidingDoor = (_p) => (<SVG svg={SinglesSlidingDoorSvg}/>);
import ArrowCompasSvg from './skema/arrow_compas.svg';
export const ArrowCompas = (_p) => (<SVG svg={ArrowCompasSvg}/>);
import EnvAnalysisFacadeSvg from './skema/EnvAnalysisFacade.svg';
export const EnvAnalysisFacade = (_p) => (<SVG svg={EnvAnalysisFacadeSvg}/>);
import EnvAnalysisFloorsSvg from './skema/EnvAnalysisFloors.svg';
export const EnvAnalysisFloors = (_p) => (<SVG svg={EnvAnalysisFloorsSvg}/>);
import CenterPointSvg from './skema/CenterPoint.svg';
export const CenterPoint = (_p) => (<SVG svg={CenterPointSvg}/>);
import UnitArrangeToolSvg from './skema/UnitArrangeTool.svg';
export const UnitArrangeTool = (_p) => (<SVG svg={UnitArrangeToolSvg}/>);
import UnitArrangmentToolSvg from './skema/UnitArrangmentTool.svg';
export const UnitArrangmentTool = (_p) => (<SVG svg={UnitArrangmentToolSvg}/>);
import SkemaLogoBetaPng from './skema/Skema_logo_Beta.svg';
export const SkemaLogoBeta = SkemaLogoBetaPng;
import SkemaLogoPng from './skema/skema_logo.svg';
export const SkemaLogoIcon = (_p) => (<SVG svg={SkemaLogoPng}/>);
